import $ from "jquery";
import React from "react";
import FontAwesome from "react-fontawesome";
import ReactHtmlParser from "react-html-parser";
import { Button, Col, Collapsible, CollapsibleItem, Collection, CollectionItem, Icon, Input, Modal, Row, Tab, Tabs } from "react-materialize";
import { notify } from "react-notify-toast";
import ReactPlayer from "react-player";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { ShareButtons } from "react-share";
import StarRatings from "react-star-ratings";
import YouTube from "react-youtube";
import ReactTooltip from "simple-react-tooltip";
import store from "store";
import { check, play } from "../../assets";
import "../../styles/course-detail.css";
import "../../styles/course-rating-modal.css";
import Image from "../Image";
import { alert, trans } from "../Lang";
import Page from "../Page";
import VideoPlayer from "../Reuseables/VideoPlayer";
import RatingModal from "../Reuseables/RatingModal";
import RefJournal from "../Reuseables/RefJournals";
import UserConstants from "../User/Constants";
import { API_COURSE_BASE_URL,API_WEBINAR_STATUS_COURSE_USER, API_UPLOAD_UPRAK, API_CHECK_UPRAK, API_DELETE_UPRAK, BASE_URL, CheckAuth, FormatDateIndo, FormatPrice, QueryParam, API_UJIAN_PRAKTEK, API_ABSEN_WEBINAR, API_ABSEN_KUIS, API_UPLOAD_TPM, API_DELETE_TPM, API_CHECK_TPM, API_GET_GAME_QUIZ } from "../Util";
import BuyCourseButton from "./BuyCourseButton";
import CourseItem from "./CourseItem";
import LearningPathItem from "./LearningPathItem";
import * as rdd from 'react-device-detect';
import ProgressBar from './ProgressBar';
import "../../styles/removeyoutuberecomend.css";
import CKEditor from 'ckeditor4-react';

import MultipleChoiceGame from '../GameQuiz/MultipleChoiceQuiz'
import SearchWordGame from '../GameQuiz/SearchWordGame'
import WordMatchingGame from '../GameQuiz/WordMatchingGame'
import { API_BASE_URL } from '../Util';

class CourseDetail extends Page {
	static TYPE_VIDEO = 1;
	static TYPE_AUDIO = 2;
	static TYPE_PDF = 3;
	static TYPE_QUIZ = 4;
	static TYPE_GAME = 5;

	static COURSE_PLAYED = 1;
	static COURSE_PAUSED = 2;
	static COURSE_ENDED = 3;
	static COURSE_ERROR = 4;

	static ZOOM_STEP = 0.1;

	constructor(props) {
		super(props);
		this.timer = 0;
		this.state = {
			isFirstScroll: true,
			data: null,
			uuid: props.match.params.uuid,
			enrolling: props.match.params.enroll,
			//redeem_coupon: CheckAuth().is_businessman === 0,
			content_rating: 0,
			media_rating: 0,
			benefit_rating: 0,
			comment: "",
			isPlaying:0,
			tipeResource:0,
			openModalVideo:false,
			isOpenModalVideo:false,
			eventState:null,
			timeRunning:0,
			countView:0,
			intervalStopVideo:0,
			isResourceTypeVideo:false,
			progressCourse: { bgcolor: "#fa0207", completed: 0,alldata:0,countComplete:0,uncompleted:0 },
			progressCount: { all: 0, completed: 0, uncompleted: 0 },
			countDownTimerPause:0,
			dataApi:[],
			datasubarr:[],
			filterIsVideoKuis:[],
			status_webinar:false,
			upload_uprak: false,
			have_upload_uprak: false,
			upload_tpm: false,
			have_upload_tpm: false,
			course_uuid: null,
			kuis_webinar: [],
			kuis_absensi: [],
			uploaded: [],
			uploaded_tpm: [],
			completed: false,
			is_uprak:"",
			is_review:false,
			user_has_reviewed:false,
			is_load_uprak:true,
			uprak: {
				is_passed: null,
				max_uploadfile: 0,
				max_file: false,
				score: 0,
			},
			uprak_tpm: {
				is_passed: null,
				max_uploadfile: 0,
				max_file: false,
				score: null,
			},
			loading_tpm:true,
			delete_file_loading: false,
			uprak_text: {
				title: '',
				text: '',
			},
			absent_code: '',
			absent_code_quiz: '',
			errorAbsentCode: '',
			errorAbsentCodeQuiz: '',
			absent_loading: false,
			isFullScreen: false,
			link_materi:'',
			slug_kelas: '',
			videoInterval: null,
			videoTime: 0,
			custom_modal: {
				content_html: null,
			},
			gameQuiz_data:"",
			isRefJournalOpen: false,
			refjournalHasAnswered: false,
			comments_refJournal:[],
			errorUpload:'',
			topic_videoUrl:'',
			isPopUpQuizTrue:null,
			notifPopUpQuizMessage:'',
			isModalResolutionPop:false,
			vermuk_loader: false
		};
	}

	async componentDidMount() {
		await this.handleLoadData(this.state.enrolling);
		window.addEventListener("resize", this.updateDimensions);
		super.componentDidMount();
		// this.handleLoadData(this.state.enrolling);
		setTimeout(function(){()=>this.raflesngln() }, 3000);
		$(".btn-help").hide();
		// {this.state.eventState ? ()=>this.hitungPersentase() : ''}
		window.addEventListener("blur", this.onFocus)
		
		var ini = this;

		window.addEventListener("fullscreenchange", function() {
			ini.setState({isFullScreen: !ini.state.isFullScreen});
		 }, false);
	}

	componentDidUpdate(prevProps, prevState) {
		let activeTopic = this.state.topic;
		let { data } = this.state;
		let prevData = prevState.data;
		if (prevState.topic !== activeTopic) {
			prevState.topic.selected = false;
			activeTopic.selected = true;
			this.setState({ topic: activeTopic });
		}
		if (prevState.timeRunning !== this.state.timeRunning) {
			if(this.state.isPlaying==1){
				  this.setState({
					timeRunning:this.state.eventState.target.playerInfo.currentTime
				  });
			}
		}
		// Attach a scroll event listener to detect the first scroll event
		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillReceiveProps(props) {
		let params = QueryParam();
		let uuid = props.match.params.uuid;
		// this.setState({ uuid: props.match.params.uuid, data: null },() => this.hitungPersentase());
		this.setState({ uuid: props.match.params.uuid, data: null });
		this.handleLoadData(this.state.enrolling, uuid);
	}

	updateDimensions = () => {
		this.setState({ width: $(window).width(), height: $(window).height() });
	};

	componentWillMount = function () {
		this.updateDimensions();
		setTimeout(function(){$("#btnTriggerProgressLoad").trigger("click"); }, 4000);
	};

	componentWillUnmount = function () {
		window.removeEventListener("resize", this.updateDimensions);
		window.removeEventListener("focus", this.onFocus)

		// Remove the scroll event listener when the component unmounts
		window.removeEventListener('scroll', this.handleScroll);
	};

	
	
	onFocus = () => {
		let eventState=this.state.eventState;
		if(eventState !==null && eventState !=''){
			this.handleOpenModalVideo()
		}
	}

	handleScroll = () => {
		// Check if it's the first scroll event
		if (this.state.isFirstScroll) {
		  // Update the state to indicate that the first scroll event has occurred
		  this.setState({ isFirstScroll: false });
		}
	  };

	handleLoadData = (enroll, uuid) => {
		
		// this.setState({dataApi:[]})
		uuid = uuid ? uuid : this.state.uuid;

		$.getJSON(API_COURSE_BASE_URL + uuid).then(data => {
			this.setState({
				course_uuid: data.payload.uuid,
				completed: data.payload.completed,
				link_materi: data.payload.course_material,
				slug_kelas: data.payload.slug,
				is_uprak: data.payload.is_practical_exam,
				user_has_reviewed: data.payload.has_reviewed,
				comments_refJournal: data.payload.refjournals,
				refjournalHasAnswered: data.payload.refjournalHasAnswered,
				is_dummy: (data.payload.is_dummy)? true:false
			});
			this.loadStatusWebinnar(data.payload.uuid);
			let { payload } = data;
			var topicUuid = window.location.hash.substr(1);
			var topic = data.payload.modules[0].topics[0];
			var moduleIndex = 0;
			if(topic.resource_type === 1){
				$("#resolution-video-btn").trigger("click")
			}
			var isLogin = (CheckAuth() !== false);
			
			if(isLogin && this.state.is_uprak){
				let formData = new FormData();
				formData.append('uuid', this.state.course_uuid);
				$.ajax({
					url: API_CHECK_UPRAK,
					data: formData,
					type: 'POST',
					contentType: false, 
					processData: false,
				})
				.then(data => {
					
					if(data.payload.is_passed != null &&
						data.payload.is_passed.is_passed == 1){
						this.state.is_review = !this.state.user_has_reviewed
					}
					this.setState({
						is_load_uprak : false
					})
				})
			}
			
			const modules_have_webinar = data.payload.modules.filter(module => module.description == 'CLASS_WEBINAR');

			for (let i in modules_have_webinar) {
				const webinar_quiz = modules_have_webinar[i].topics.filter(topic => topic.resource_type == CourseDetail.TYPE_QUIZ);

				if(webinar_quiz.length > 0) {
					// this.state.kuis_webinar.push(webinar_quiz);
					this.setState({
						kuis_webinar: [this.state.kuis_webinar, ...webinar_quiz]
					})
				}
			}

			const modules_quiz_absent = data.payload.modules.filter(module => module.description == 'KUIS_ABSENSI');

			for (let i in modules_quiz_absent) {
				const quiz_absent = modules_quiz_absent[i].topics.filter(topic => topic.resource_type == CourseDetail.TYPE_QUIZ);
				
				if(quiz_absent.length > 0) {
					// this.state.kuis_webinar.push(webinar_quiz);
					this.setState({
						kuis_absensi: [...this.state.kuis_absensi,...quiz_absent]
					})
					
				}
			}
			
			// setTimeout(()=>{
				// 	this.setState({
					// 		kuis_webinar: kuis_webinar.flat()
					// 	});
			// },500)
			
			var isLogin = (CheckAuth() !== false);

			if (isLogin) {
				this.checkHaveUploadUprak();
			}

			if (topicUuid) {
				for (var i in data.payload.modules) {
					var topics = data.payload.modules[i].topics;
					for (var j in topics) {
						if (topicUuid == topics[j].uuid && !topics[j].locked) {
							topic = topics[j];
							moduleIndex = i;
							break;
						}
					}	
				}
			}
			
			if (topic) {
				topic.module_title = data.payload.modules[moduleIndex].title;
				topic.selected = true;
			}
			
			if (data.payload.voucher_redeemable) {
				data.payload.user_cashback = 0;
			}

			let alertSeen = store.get(this.getAlertKey());

			this.setState({
				data: data.payload,
				topic: topic,
				alert_seen: alertSeen,
				// dataApi:data.payload
			},() => {this.hitungPersentase()});

			$(".meta-title").attr("content", data.payload.title);
			$(".meta-image").attr("content", data.payload.thumbnail);
			$(".meta-description").attr("content", data.payload.description);

			// $("video").bind("contextmenu",function(){
			//   return false;
			// });
			
			if (enroll) {
				this.doEnroll();
			} else if (this.state.enrolling) {
				notify.show(
					`${trans.you} ${trans.successfully} ${trans.registered}`,
					"success"
				);
			}

			if (store.get(`completed_${uuid}`)) {
				store.remove(`completed_${uuid}`);
				$("#graduate-btn").trigger("click");
			}

		});
	};

	tpmSorting = (modules) => {
		const tpmTitle = "TUGAS PRAKTIK MANDIRI"

		for(const key in modules) {
			let mod = modules[key] 
			let topics = mod.topics
			const tpmIndex = topics.findIndex(topic => topic.title.toUpperCase() == tpmTitle)

			if(tpmIndex != -1) {
				topics.push(topics.splice(tpmIndex, 1)[0]);

				this.state.data.modules[key].topics = topics
			}
		}
	}

	handleLinkMateri = (e) =>{
		window.open(`/materi/${this.state.slug_kelas}`, "_blank")
	}

	handleReset = () => {

		let param = {};
		
		$.post(API_UJIAN_PRAKTEK + this.state.course_uuid + '/reset', param)
		.then(data => {
			window.location.reload();
		})
		.fail((err) => {
			console.log(err);
		});
	}
	
	checkHaveUploadUprak = () => {
		let formData = new FormData();
		
		formData.append('uuid', this.state.course_uuid);
		
		$.ajax({
			url: API_CHECK_UPRAK,
			data: formData,
			type: 'POST',
			contentType: false, 
			processData: false,
		}).then((data) => {
			let max_file = false;
			
			if(data.payload.data.length >= data.payload.max_uploadfile) {
				max_file = true;
			}
			
			let is_passed;
			
			if(data.payload.is_passed == null) {
				is_passed = null;
			} else {
				is_passed = data.payload.is_passed.is_passed;
			}
			this.state.uploaded = data.payload.data
			this.state.uprak.is_passed = is_passed
			this.state.uprak.max_uploadfile = data.payload.max_uploadfile
			this.state.uprak.max_file = max_file
			this.state.uprak.score = (data.payload.is_passed != null)?data.payload.is_passed.score:""
		});
	}

	handleReuploadUjianPraktek = () => {
		const file = $('#uprak-input-file').prop('files')[0]
		this.handleUploadUjianPraktek(null, file)
	}
	
	handleUploadUjianPraktek = (e = null, file = null) => {
		console.log('cek file',file);
		this.setState({
			upload_uprak: true
		});
		
		if(!file && e) file = e.target.files[0];

		let formData = new FormData();

		formData.append('file', file);
		formData.append('uuid', this.state.course_uuid);
		
		$.ajax({
			url: API_UPLOAD_UPRAK,
			data: formData,
			type: 'POST',
			contentType: false, 
			processData: false,
		}).then((data) => {
			this.setState({
				upload_uprak: false,
				have_upload_uprak: true,
			});
			this.checkHaveUploadUprak();
			// notify.show('Upload berhasil', "success");
			$("#success-upload-notif-button").trigger("click")
			
			let uprakTopic = this.state.data.modules[this.state.data.modules.length - 1]
			let uprakIndex = uprakTopic.topics.length - 1
			let content = "[data-topickey='" + uprakIndex + "']" 
			setTimeout(() => {
				document.querySelector(content).click()
			}, 500);
		}).catch((error) => {
			
			/*if(error.responseJSON.message.toLowerCase() == "upload ujian praktek belum dimulai"
				|| error.responseJSON.message.toLowerCase() == "anda belum lulus post test"
				|| error.responseJSON.message.toLowerCase() == "upload ujian praktek sudah dinilai")
			{
				notify.show(error.responseJSON.message, "warning");
				this.setState({
					upload_uprak: false,
				});
				return false;
			}*/
			let errMessage = "";
			
			if(error.responseJSON.errors){
				errMessage = error.responseJSON.errors.file[0];
			}
			else if(error.responseJSON.message){
				errMessage = error.responseJSON.message;
			}
			
			this.setState({errorUpload:errMessage})
			// notify.show('Terdapat error pada file yang diupload', "danger");
			$("#failed-upload-notif-button").trigger("click")
			
			this.setState({
				upload_uprak: false,
			});
			return false;
		});
	}

	checkHaveUploadTugasPraktik = (activeTopic) => {
		let formData = new FormData();

		formData.append('uuid', this.state.course_uuid);
		formData.append('topic_uuid', activeTopic.uuid);

		$.ajax({
			url: API_CHECK_TPM,
			data: formData,
			type: 'POST',
			contentType: false, 
			processData: false,
		}).then((data) => {
			let max_file = false;
			
			if(data.payload.data.length >= 1) {
				max_file = true;
			}
			
			let is_passed;
			
			if(data.payload.is_passed == null) {
				is_passed = null;
			} else {
				is_passed = data.payload.is_passed.is_passed;
			}

			let score = null

			if(!data.payload.is_passed) score = null
			else if(data.payload.is_passed) score = data.payload.is_passed.score

			this.setState({
				uploaded_tpm: data.payload.data,
				uprak_tpm:{
					is_passed,
					max_file,
					score,
					max_uploadfile : 1,
					comment: data.payload.comment
				}
			})
		});
	}

	handleUploadTugasPraktik = (e, activeTopic) => {
		this.setState({
			upload_tpm: true
		});
		var file = e.target.files[0];
		let formData = new FormData();

		formData.append('file', file);
		formData.append('uuid', this.state.course_uuid);
		formData.append('topic_uuid', activeTopic.uuid);
		
		$.ajax({
			url: API_UPLOAD_TPM,
			data: formData,
			type: 'POST',
			contentType: false, 
			processData: false,
		}).then(async(data) => {
			this.setState({
				upload_tpm: false,
				have_upload_tpm: true,
			});
			await this.handleLoadData(this.state.enrolling);
			this.checkHaveUploadTugasPraktik(activeTopic);
			notify.show('Terima kasih, tugas praktik mandiri Anda telah kami terima. Silakan lanjutkan ke sesi berikutnya', "success");

			for(let i in this.state.data.modules){
				for(let j in this.state.data.modules[i].topics){
					if(this.state.data.modules[i].topics[j].uuid == activeTopic.uuid){
						var searchModul = this.state.data.modules[i]
						var findIndexTopic = searchModul.topics.findIndex(topic => topic.uuid == activeTopic.uuid )
					}
				}
			}
			let findIndexModul = this.state.data.modules.findIndex(modul => modul == searchModul)
			let currentModulIndex = "[data-modulekey='" + findIndexModul + "']"

			// let uprakTopic = this.state.data.modules[this.state.data.modules.length - 1]
			// let uprakIndex = uprakTopic.topics.length - 1
			let content = "[data-topickey='" + findIndexTopic + "']" 

			setTimeout(() => {
				document.querySelector(currentModulIndex+''+content).click()
			}, 1000);
		}).catch((error) => {
			let errMessage = "";
			
			if(error.responseJSON.errors){
				errMessage = error.responseJSON.errors.file[0];
			}
			else if(error.responseJSON.message){
				errMessage = error.responseJSON.message;
			}
			
			this.setState({errorUpload:errMessage})
			// notify.show('Terdapat error pada file yang diupload', "danger");
			$("#failed-upload-notif-button").trigger("click")

			this.setState({
				upload_tpm: false
			});
			return false;
		});
	}

	renderFileName = (filename, window_size) => {
		let extension = filename.split(".");
		extension = extension[extension.length - 1];
		let name = filename.split("_");
		
		name.pop();
		
		name = name.join('_');
		let new_name;
		if(name.length >= 20 && window_size == 'mobile'){
			let name_arr = name.split('')
			for(let i in name_arr){
				if(i == 24){
					name_arr.splice(i, 0, '\n');
				}
			}
			// new_name = name.slice(0, 24)
			new_name = name_arr.join('')
			return new_name  + '.' + extension;
		}
		return name  + '.' + extension;
	}

	checkUprakLocked = (topic,index,index_completed) => {
		if(topic.title == 'UJIAN PRAKTEK') {
			return this.state.completed == true ? false : true;
		}else {
			if(topic.locked){
				return true;
			}else{
				if(topic.completed){
					return false;
				}else{
					if( index == index_completed || index==0){
						return false;	
					}else{
						let index_pdf = index + 1;
						if(topic.resource_type == CourseDetail.TYPE_PDF && index_pdf == index_completed){
							return false
						}else{
							return true;
						}
					}
				}
			}
		}
	}

	deleteFile = (file_id) => {
		this.setState({
			delete_file_loading: true
		});

		let formData = new FormData();

		formData.append('file_id', file_id);
		
		$.ajax({
			url: API_DELETE_UPRAK,
			data: formData,
			type: 'POST',
			contentType: false,
			processData: false,
		}).then((data) => {
			this.setState({
				delete_file_loading: false,
			});
			this.checkHaveUploadUprak();

			$("#success-delete-notif-button").trigger("click")
			// notify.show('Hapus file berhasil', "success")

			let uprakTopic = this.state.data.modules[this.state.data.modules.length - 1]
			let uprakIndex = uprakTopic.topics.length - 1
			let content = "[data-topickey='" + uprakIndex + "']" 
			setTimeout(() => {
				document.querySelector(content).click()
			}, 500);
		}).catch((error) => {
			notify.show(error.responseJSON.message, "danger");
		});
	}

	deleteFileTugasPraktik = (file_id,activeTopic) => {
		this.setState({
			delete_file_loading: true,
			uprak_tpm:{
				max_file: false
			}
		});

		let formData = new FormData();

		// formData.append('file_id', file_id);
		formData.append('uuid', this.state.course_uuid);
		formData.append('topic_uuid', activeTopic.uuid);
		
		$.ajax({
			url: API_DELETE_TPM,
			data: formData,
			type: 'POST',
			contentType: false,
			processData: false,
		}).then(async(data) => {
			this.setState({
				delete_file_loading: false,
			});
			this.checkHaveUploadTugasPraktik(activeTopic);
			notify.show('Hapus file berhasil', "success");

			await this.handleLoadData(this.state.enrolling);
			

			for(let i in this.state.data.modules){
				for(let j in this.state.data.modules[i].topics){
					if(this.state.data.modules[i].topics[j].uuid == activeTopic.uuid){
						var searchModul = this.state.data.modules[i]
						var findIndexTopic = searchModul.topics.findIndex(topic => topic.uuid == activeTopic.uuid )
					}
				}
			}
			let findIndexModul = this.state.data.modules.findIndex(modul => modul == searchModul)
			let currentModulIndex = "[data-modulekey='" + findIndexModul + "']"

			// let uprakTopic = this.state.data.modules[this.state.data.modules.length - 1]
			// let uprakIndex = uprakTopic.topics.length - 1
			let content = "[data-topickey='" + findIndexTopic + "']" 

			setTimeout(() => {
				document.querySelector(currentModulIndex+''+content).click()
			}, 1000);
		}).catch((error) => {
			notify.show("Gagal menghapus file", "danger");
		});
	}
	
	renderUploadButton = () => {
		return (
			<div className="d-flex-jc-center wrapper-form-uprak mb-xss pt-s pb-s">
				<div className="mr-xs">
					<Modal
						id="rich-text-box-modal"
						className="rich-text-box-modal"
						trigger={<button className="btn capitalize btn-small">Ketik Ujian Praktek</button>}
						modalOptions={{ dismissible: false }}
						options={{
								endingTop: '10%',
								inDuration: 250,
								onCloseEnd: null,
								onCloseStart: null,
								onOpenEnd: null,
								onOpenStart: null,
								opacity: 0.5,
								outDuration: 250,
								preventScrolling: true,
								startingTop: '4%'
						}}
					>
						<div className="rich-text-title-wrapper">
							<label for="rich-text-title">Judul</label>
							{/* <input name="rich-text-title" type="text" onChange={this.handleRichTextTitle} placeholder="Masukkan Judul" /> */}
							<input name="rich-text-title" id="rich-title-uprak" type="text" placeholder="Masukkan Judul" />
						</div>
						<div className="center almost-full rich-text-box-modal">
							{this.renderRichTextBox()}
						</div>
					</Modal>
				</div>
				<form id="form-upload-ujian-praktek" className="form-uprak ml-xs">
					<div id="upload_button">
						<label>
							<input id="uprak-input-file" name="file" onChange={this.handleUploadUjianPraktek} type="file" />
							<span className="btn capitalize btn-small">Upload Hasil Praktek Kamu</span>
						</label>
					</div>
				</form>
				<button id="hidden-btn" style={{display:'none'}}>Hidden</button>
			</div>
		)
	}

	renderUploadButtonTugasPraktik = (activeTopic) => {
		return (
			<div className="d-flex-jc-center wrapper-form-uprak mb-xss pt-s pb-s">
				<form id="form-upload-ujian-praktek" className="form-uprak ml-xs">
					<div id="upload_button">
						<label>
							<input name="file" onChange={(e)=>this.handleUploadTugasPraktik(e,activeTopic)} type="file" />
							<span className="btn capitalize btn-small">Upload Hasil Praktik Kamu</span>
						</label>
					</div>
				</form>
			</div>
		)
	}
	
	renderRichTextBox = () => {
		return (
			<div>
				<CKEditor
					data={this.state.uprak_text.text}
					config={{
						versionCheck: false,
						removeButtons: 'Image,ImageButton,Link,Unlink,Cut,Copy,Paste,PasteText,PasteFromWord,Anchor'
					}}
					onChange={this.handleChange}
				/>
				<div className="d-flex-jc-center mt-xs mb-s">
					<button className="btn capitalize btn-small mr-xs" onClick={this.sendRichTextUprak}>Kirim</button>
					<button className="btn capitalize btn-small bg-danger uprak-modal-close modal-close">Cancel</button>
				</div>
			</div>
		)
	}

	handleChange = (evt) => {
      // this.setState({
		// 		uprak_text: {
		// 		text: evt.editor.getData(),
		// 		title: this.state.uprak_text.title
		// 	}
      // });
		this.setState((prevState) => ({
			uprak_text: {
				...prevState.uprak_text,
				text: evt.editor.getData(),
			},
		}));
   }

	handleAbsentCodeChange = (e) => {
		let { value } = e.target;

		this.setState({
			absent_code: value
		})
	}

	handleAbsentCodeChangeQuiz = (e) => {
		let { value } = e.target;

		this.setState({
			absent_code_quiz: value
		})
	}

	submitAbsentCode = () => {
		let validate = this.validateAbsentCode();

		if(validate) {
			this.setState({ absent_loading: true })

			let formData = {
				course_uuid: this.state.course_uuid,
				kode: this.state.absent_code
			}

			$.post(API_ABSEN_WEBINAR, formData)
			.then((data) => {
				notify.show("Absensi berhasil. Silahkan melanjutkan kuis", 'success')
				$("#kode-absensi-modal-close").trigger("click")
				$(".modal-overlay").trigger("click")
				this.setState({ status_webinar: true, absent_loading: false })
			})
			.fail((data) => {
				notify.show(data.responseJSON.message, "warning")
				this.setState({ absent_loading: false })
			});
		}
	}

	submitAbsentCodeQuiz = (value, uuid) => {
		let validate = this.validateAbsentCodeQuiz();

		if(validate) {
			this.setState({ absent_loading: true })

			let formData = {
				course_uuid: this.state.course_uuid,
				kode: this.state.absent_code_quiz,
				quiz_uuid: uuid
			}

			$.post(API_ABSEN_KUIS, formData)
			.then((data) => {
				notify.show("Absensi berhasil. Silahkan melanjutkan kuis", 'success')
				$("#kode-absensi-modal-close").trigger("click")
				$(".modal-overlay").trigger("click")
				this.setState({ status_webinar: true, absent_loading: false })
				this.state.kuis_absensi.map((kuis,index) => kuis.uuid == uuid ? this.state.kuis_absensi[index].hasAbsent = true : "")
			})
			.fail((data) => {
				notify.show(data.responseJSON.message, "warning")
				this.setState({ absent_loading: false })
			});
		}
	}

	validateAbsentCode = () => {
		let validate = true;
		let errorMessage = '';

		if(!this.state.absent_code) {
			errorMessage = "Kode Absen wajib diisi"
			validate = false;
		}

		this.setState({
			errorAbsentCode: errorMessage
		})

		return validate;
	}

	validateAbsentCodeQuiz = () => {
		let validate = true;
		let errorMessage = '';

		if(!this.state.absent_code_quiz) {
			errorMessage = "Kode Absen wajib diisi"
			validate = false;
		}

		this.setState({
			errorAbsentCodeQuiz: errorMessage
		})

		return validate;
	}

	// handleRichTextTitle = (e) => {
	// 	this.setState((prevState) => ({
	// 		uprak_text: {
	// 		  ...prevState.uprak_text,
	// 		  title: e.target.value,
	// 		},
	// 	 }));
	// 	console.log('cek text',e.target);
	// }

	sendRichTextUprak = () => {
		let title = document.querySelector('#rich-title-uprak').value
		if(title.length === 0 || this.state.uprak_text.text.length <= 30){
			return(
				notify.show('Judul tidak boleh kosong dan isi minimal terdiri dari 30 karakter', "warning")
			)
		}
		
		// this.setState({
		// 	upload_uprak: true
		// });

		// document.querySelector('.uprak-modal-close').click()
		
		let formData = new FormData();


		formData.append('title', title);
		formData.append('text', this.state.uprak_text.text);
		formData.append('uuid', this.state.course_uuid);
		
		// document.querySelector('.uprak-modal-close').click()
		$.ajax({
			url: API_UPLOAD_UPRAK,
			data: formData,
			type: 'POST',
			contentType: false,
			processData: false,
		}).then((data) => {
			this.setState({
				upload_uprak: false,
				have_upload_uprak: true,
				uprak_text: {
					title: '',
					text: '',
				},
			});
			this.checkHaveUploadUprak();
			// notify.show('Upload berhasil', "success")
			$('.uprak-modal-close').trigger('click')
			$('#success-upload-notif-button').trigger('click')
			setTimeout(() => {
				document.querySelector('#hidden-btn').click()
				document.querySelector('#rich-title-uprak').value = ''
			}, 1000);
		}).catch((error) => {
			let message = 'Upload gagal, silakan upload ulang'

			if(error.responseJSON.message){
				
				if(error.responseJSON.message == "text_too_short") message = 'Isi text terlalu pendek, min. 30 karakter';
				else message = error.responseJSON.message

			}

			this.setState({
				upload_uprak: false,

				custom_modal: {
					content_html: (
						<div className="text-center">
							<h5 className="text-danger">Gagal mengirim!</h5>

							<p>{ message }</p>

							<div className="d-flex-jc-center">
								<button className="btn btn-small delete-btn bg-success modal-close">Oke</button>
							</div>
						</div>
					)
				}
			})

			$('#custom-notif-button').trigger('click')

			return false

			// if(error.responseJSON.message == "text_too_short")
			// {
			// 	notify.show("Isi text terlalu pendek, min. 30 karakter", "warning");
			// 	this.setState({
			// 		upload_uprak: false,
			// 	});
			// 	return false;
			// }

			// notify.show('Upload gagal, silakan upload ulang', "warning");
			// this.setState({
			// 	upload_uprak: false,
			// });
			// return false;
		});

		//document.querySelector('.uprak-modal-close').click()
	}

	loadStatusWebinnar = (uuid) => {
		let param = {
			uuid: uuid,		
		};
		$.post(API_WEBINAR_STATUS_COURSE_USER, param)
			.then(data => {
				this.setState({
					status_webinar: data.payload,
				});
			})
			.fail(() => {
				console.log("Module progress not sent due to error");
			});
	}

	getAlertKey = () => {
		return "alert_seen_" + CheckAuth().email + "_" + this.state.uuid;
	};

	handleCloseAlert = () => {
		let alertKey = this.getAlertKey();
		store.set(alertKey, true);
		this.setState({ alert_seen: true });
	};

	doEnroll = e => {
		if (CheckAuth() === false) {
			this.setState({ enrolling: true });
			notify.show(
				`${trans.you} ${trans.must} ${trans.login} ${trans.first}`,
				"warning"
			);
			return;
		}

		$("#btn-modal-enroll").trigger("click");
		$(".loading").hide();
	};

	handleRedeem = e => {
		if (!this.checkLogin()) {
			return;
		}
		$("#btn-redeem").trigger("click");
		$(".loading").hide();
	};

	handleEnroll = e => {
		e.preventDefault();
		if (e.target.id === "prakerja") {
			this.props.history.push("/prakerja");
			return;
		}
		const { data } = this.state;
		const itemType = "course";

		if (
			(data.payment_status && data.payment_status === -4) ||
			(data.payment_status && data.payment_status === -5)
		) {
			notify.show(
				"Anda sudah memilih modul ini, lanjutkan transaksi anda terlebih dahulu",
				"warning"
			);
		} else {
			if (CheckAuth()) {
				this.props.history.push("/payment", { data, itemType });
			} else {
				this.props.history.push("/login");
			}
		}
	};

	finishEnroll = redirectUrl => {
		$(".modal-close").trigger("click");
		$(".loading").hide();
		this.props.history.push(redirectUrl);
	};

	handleResolutionVideo = (resolution) => {
		const splitUrl = this.state.topic.resource_url.split('|')
		let eventState = this.state.eventState
		if(resolution === 360){
			this.setState({topic_videoUrl: splitUrl[1]})
			eventState.target.playVideo();
		}else{
			this.setState({topic_videoUrl: splitUrl[3]})
			setTimeout(() => {
				eventState.target.playVideo();
			}, 500);
		}
		this.setState({countDownTimerPause: 3});
	}
	
	// handleClick = (i, j, locked, e) => {
	handleClick = (i, j, locked,resource_type, title, data_topic, e, isQuiz) => {
		this.noteVideoState('reset')
		if (e) e.preventDefault();
		// this.hitungPersentase()
		this.setState({ countDownTimerPause: 0 });
		let topic = null;
		if(title == 'TUGAS PRAKTIK MANDIRI'){
			this.checkHaveUploadTugasPraktik(data_topic)
		}
		var mainSub=i;
		var subModul=(j); //this recent index decreement 1/ check before index are there any false complete status
		
		let beforethisindex=(j); //this recent index decreement 1/ check before index are there any false complete status

		var arr_sts=[];
		var all_main_sub=[];
		var submenuArr=[];
		for (let k = 0; k < i; k++) {
			// let cekResource_type=this.state.data.modules[i].topics[k].resource_type;
			let itemSub=this.state.data.modules[k];
			all_main_sub=[...all_main_sub,itemSub];
			var subArr=itemSub.topics;
			for (let indx = 0; indx < subArr.length; indx++) {
				let listitems=subArr[indx];
				submenuArr=[...submenuArr,listitems];
				
			}
			// all_main_sub = all_main_sub.concat(obj);

			// if(cekResource_type==1){
			// 	var cekModulCompleteBeforeStatus=this.state.data.modules[i].topics[k].completed;
			// } else{
			// 	var cekModulCompleteBeforeStatus=true;
			// }
			// arr_sts=[...arr_sts,cekModulCompleteBeforeStatus];
		}
		var cek = arr_sts.includes(false);
		let all_item_above=submenuArr.map((val)=>val)
		let filter_kuis_video = submenuArr.filter(   // search data videos/kuis its completed=false
			(vals) =>
			  vals.completed == false &&
			  (vals.resource_type == 1 || vals.resource_type == 4)
		  );

		// let all_item_above=submenuArr.map((val)=>val)
		this.setState({dataApi:all_main_sub,datasubarr:all_item_above,filterIsVideoKuis:filter_kuis_video})

		

		let Msg_info=(filter_kuis_video.length > 0)?'Anda harus menyelesaikan BAB sebelumnya terlebih dahulu'
				:`${trans.you} ${trans.must} ${trans.finish} ${trans.chapter} sebelumnya ${trans.first}`;

		//not first topic in module
		if(j > 0 && data_topic.locked == false) {
			Msg_info = 'Anda harus menyelesaikan TOPIK sebelumnya terlebih dahulu'
		}

		if (title == 'UJIAN PRAKTEK') {
			Msg_info = 'Anda harus menyelesaikan Post Test terlebih dahulu';
		}

		if (locked || filter_kuis_video.length >0) {
			var message = this.state.data.enrolled ? (
				// <span>{`${trans.you} ${trans.must} ${trans.finish} ${trans.chapter} sebelumnya ${trans.first}`}</span>
				<span>{`${Msg_info}`}</span>
			) : (
				<span>{`${trans.you} ${trans.must} ${trans.register} ${trans.first}`}</span>
			);
			notify.show(message, "warning");
		} else {
			if(data_topic.resource_type === 1){
				this.setState({topic_videoUrl: data_topic.resource_url, isModalResolutionPop: false})
			}
			let module = this.state.data.modules[i];
			if(isQuiz){
				let previousTopic = module.topics[j-1]
				previousTopic.completed = true
				previousTopic.popup_quiz_answered = true
				this.setState({module})
			}
			if (module) {
				topic = module.topics[j];
				topic.module_title = module.title;
				topic.selected = true;
				this.setState({ topic: topic });
				$(".hls-player").attr("autoplay", "autoplay");
			} else {
				notify.show(i + " : " + j + " :" + locked);
				//notify.show('Terjadi kesalahan, silakan coba lagi', "error");
			}
		}

		if (
			this.state.width < 800 ||
			(topic && topic.resource_type == CourseDetail.TYPE_QUIZ)
		) {
			super.scrollToTop(50);
		}
	};

	handlePinChange = e => {
		var errorMessage = "";
		var pinPattern = /^\d{6}$/;

		if (!pinPattern.test(e.target.value)) {
			errorMessage = alert.invalid_pin_digit;
		}

		this.setState({ errorMessage: errorMessage });
	};

	handleTypePin = event => {
		var charCode = parseInt(event.charCode);
		if (charCode != 13 && (charCode < 48 || charCode > 57)) {
			event.preventDefault();
		}
	};

	getResourceIcon = topic => {
		var icon = "";
		let { completed, selected, resource_type } = topic;

		if (selected && completed && resource_type === CourseDetail.TYPE_QUIZ ) {
			return <img src={check} id="custom-resource-icon" />;
		}
		else if (selected) {
			return <img src={play} id="custom-resource-icon" />;
		}
		else if (completed) {
			return <img src={check} id="custom-resource-icon" />;
		} else if (resource_type === CourseDetail.TYPE_VIDEO) {
			return (
				<img
					src="/img/icon/course/video.png"
					style={{position:'absolute', top:'15px', left:'10px'}}
				/>
				// <Icon className="left" small>
				// 	video_library
				// </Icon>
			);
		} else if (resource_type === CourseDetail.TYPE_AUDIO) {
			return (
				<Icon className="left" small>
					headset
				</Icon>
			);
		} else if (resource_type === CourseDetail.TYPE_PDF) {
			return (
				<img
					src="/img/icon/course/pdf.png"
					style={{position:'absolute', top:'15px', left:'10px'}}
				/>
				// <Icon className="left" small>
				// 	picture_as_pdf
				// </Icon>

			);
		} else if (resource_type === CourseDetail.TYPE_QUIZ) {
			return (
				<img
					src="/img/icon/course/quiz.png"
					style={{position:'absolute', top:'15px', left:'10px'}}
				/>
				// <Icon className="left" small>
				// 	list
				// </Icon>
			);
		}

		return (
			<Icon className="left" small>
				{icon}
			</Icon>
		);
	};

	nextChapter = (isNext, isQuiz) => {
		this.setState({ videoCompleted: true })
		
		let activeModule = this.state.data.modules[this.state.dataApi.length];
		let activeTopic = this.state.topic;
		let nextIndex = 0;


		activeModule.topics.find((topic, index) => { 
			if (topic.uuid == activeTopic.uuid) {
				nextIndex = index + 1;
			}
		});
		
		let nextTopic = activeModule.topics[nextIndex];
		let lastTopic = activeModule.topics[activeModule.topics.length - 1];

		if(isQuiz){
			document.querySelector('.modal-quizGame').click() //for quiz at modal
			if(nextTopic.resource_type != 1){
				this.handleClick(this.state.dataApi.length, nextIndex, this.checkUprakLocked(nextTopic, nextIndex, nextIndex), nextTopic.resource_type, nextTopic.title, nextTopic, null, isQuiz)
			}
		}

		if(nextTopic && nextTopic.resource_type == 1) {
			this.setState({ nextChapter: true });
			if(activeTopic.uuid != lastTopic.uuid && isNext) {
				this.setState({ nextChapter: false, videoCompleted: !this.state.videoCompleted })
				this.handleClick(this.state.dataApi.length, nextIndex, this.checkUprakLocked(nextTopic, nextIndex, nextIndex), nextTopic.resource_type, nextTopic.title, nextTopic, null, isQuiz)
			}
		}
	}

	updateQuiz = (isTrue) =>{
		if(isTrue){
			this.setState({isPopUpQuizTrue: true, notifPopUpQuizMessage:'Selamat! Jawaban kamu tepat'})
		}else{
			this.setState({isPopUpQuizTrue: false, notifPopUpQuizMessage:'Silakan tingkatkan lagi proses belajar kamu yah'})
		}
	}

	onMediaAction = (event, topic, action) => {
		//console.log('cek event', event);
		this.setState({eventState:event,isPlaying:action,countView:2,timeRunning:0, videoCompleted: false},() => this.hitungPersentase())
		// this.setState({eventState:event,isPlaying:action,countView:2,timeRunning:0, videoCompleted: false})
		let { uuid } = this.state;
		const duration = this.state.eventState.target.getDuration()
		let url_link = API_COURSE_BASE_URL + uuid + "/progress";
		let param = {}
		const checkYtUrl = topic.resource_url.split('|')

		// let eventState = this.state.eventState
		//console.log('cek yt url1', checkYtUrl, this.state.eventState);
		if(checkYtUrl.length > 1 && event && !this.state.isModalResolutionPop){
			//console.log('cek yt url2', checkYtUrl);
			$("#resolution-video-btn").trigger("click")
			this.setState({isModalResolutionPop: true})
			setTimeout(() => {
				event.target.pauseVideo()
			}, 500);
		}

		if(action !== 3){
			param = {
				topic_uuid: topic.uuid,
				action: action
			};
		}else{
			param = {
				topic_uuid: topic.uuid,
				action: action,
				duration
			};

		}
		if(typeof topic.popup_quiz_answered === 'undefined'){
			this.setTopicStatus(topic, action);
		}
		$.post(url_link, param).then(data => {
				// console.log(data);
		})
		.fail(() => {
			console.log("Module progress not sent due to error");
		});

			//MODALS interval run if video playing
		if(this.state.isPlaying==1){
			//set interval pause video and show modals in count 2.update and decrement every 900000 ms (15 minutes),if countDownTimerPause 1 is stop video
			this.setState({ countDownTimerPause: 3 },
			// ()=>this.countDownIntervalStart()
			);
		} else{
			this.setState({ countDownTimerPause: 0 });
		}
		// calculate progress percent
		if(action==3){
			this.hitungPersentase()
			this.nextChapter()
			if(typeof topic.popup_quiz_answered !== 'undefined' && !topic.popup_quiz_answered){
				topic.video_has_watched = true
				this.setState({topic})
				this.toggleGameQuiz(topic.uuid)
				this.setState({gameQuiz_data:''})
				const tempTopic = {...topic}
				$.getJSON(API_GET_GAME_QUIZ + tempTopic.uuid).then(async response => {
					tempTopic.resource_type = CourseDetail.TYPE_GAME
					await this.setState({gameQuiz_data : response.payload, topic : tempTopic}, () =>{
						$("#btn-gameModal").trigger("click");
					})
				})
			}
		}

		if(action == 2) {
			this.noteVideoState('pause')
		}

		super.scrollToTop(50);
	};

	_onReadyVideo(event) {
		event.target.playVideo();
		this.hitungPersentase()
	}

	noteVideoState = (state) => {
		switch(state) {
			case 'pause': {
				clearInterval(this.state.videoInterval)

				this.state.videoInterval = null
			}
				break
			case 'reset': {
				clearInterval(this.state.videoInterval)

				this.state.videoInterval = null
				this.state.videoTime = 0
			}
				break
			default: if(!this.state.videoInterval) this.state.videoInterval = setInterval(() => this.state.videoTime += 1, 1000)
		}
	}

	// Fungsi untuk menonaktifkan captions
	disableCaptions = (event) => {
		if (event.target.unloadModule) {
			try {
				event.target.unloadModule("captions");
				event.target.unloadModule("cc");
			} catch (exception) {
				console.warn("Gagal menonaktifkan captions:", exception);
			}
		} else {
			console.warn("unloadModule tidak didukung di perangkat ini");
		}
	};

	setTopicStatus = (topic, action) => {
		if (action === CourseDetail.COURSE_ENDED) {
			topic.completed = true;
			this.setState({ topic: topic });
		} else if (
			action === CourseDetail.COURSE_PLAYED ||
			action === CourseDetail.COURSE_PAUSED
		) {
			topic.selected = true;
			this.setState({ topic: topic });
		}
	};
	onStateChangeVideo= async (evntState)=>{
		const player = await this.youtubePlayer.internalPlayer
		const videoCurrentTime = (await player.getCurrentTime())
		const videoDurationTime = (await player.getDuration())

		if(this.state.videoTime < (videoCurrentTime - 2)) player.seekTo(this.state.videoTime)

		if(this.state.videoTime > videoDurationTime) {
			this.noteVideoState('reset')
		}

		this.setState({eventState:evntState,countView:1,timeRunning:0})
		if(evntState.data==1){
		  this.setState({timeRunning:0})
		}
		// this.handleModalOpenCLose(event);
	}
	handleOpenModalVideo = () => {
		this.setState({isOpenModalVideo:false,countDownTimerPause:0})
		let eventState=this.state.eventState;
		if(this.state.isFullScreen === false){
			if(this.state.isOpenModalVideo==false && eventState !==null){
				this.setState({isOpenModalVideo:true})
				eventState.target.pauseVideo()
				$("#btn-modal-youtube").trigger("click");
				$(".loading").hide();

			}
		}
		
	};
	
	handleCloseModalVideo = () => {
		let eventState=this.state.eventState;
		// let status=event
		eventState.target.playVideo();
		this.setState({isOpenModalVideo:false})
	};
	_onReadyVideo(event) {
	  event.target.playVideo();
	}

	// countDownIntervalStart() {
	// 	//set interval pause video and show modals in count 2.update and decrement every 900000 ms (15 minutes),if countDownTimerPause 1 is stop video
	// 	if (this.state.countDownTimerPause > 0 && this.state.countDownTimerPause != 1) {
	// 	  this.timer = setInterval(this.countDownStart, 900000);
	// 	}
	//   }
	  
	countDownStart = () => {
		// Remove one second, set state so a re-render happens.
		let countdowdtimer = this.state.countDownTimerPause - 1;
		this.setState({
		  countDownTimerPause: countdowdtimer
		});
	
		// Check if we're at zero.
		if (countdowdtimer == 0) {
		  clearInterval(this.timer);
			window.scrollTo(0, 0)
		} else if(countdowdtimer==1){
			clearInterval(this.timer);
			window.scrollTo(0, 0)
			this.handleOpenModalVideo()
		}
	};

	playatMinutes = () =>{
		let eventState=this.state.eventState;
		let currentTime=this.state.eventState.target.playerInfo.currentTime;
		let playAt=this.state.eventState.target;
		eventState.target.seekTo(80);
		// seekTo
	}
	showCompleteModel = () =>{
		$("#graduate-btn").trigger("click");
		
	}
	PlayPauseVideo(){
		if(this.state.videoCompleted) {
			this.setState({ videoCompleted: false })
		}
		let eventState=this.state.eventState;
		let isPlaying=this.state.isPlaying;
		if(isPlaying==1){
			eventState.target.pauseVideo();
			this.setState({countDownTimerPause: 0});
			super.scrollToTop(50);
			
		}else{
			eventState.target.playVideo();
			this.setState({ countDownTimerPause: 3 },
				// ()=>this.countDownIntervalStart()
				);
			super.scrollToTop(50);
		}
	}

	toggleGameQuiz = (uuid) => {
		const tempTopic = {...this.state.topic}
		$.getJSON(API_GET_GAME_QUIZ + uuid).then(response => {
			tempTopic.resource_type = CourseDetail.TYPE_GAME
			this.setState({gameQuiz_data : response.payload, topic : tempTopic})
		})
	}

	toggleFullScreen = () => {
			var el = document.getElementById("YTVideo")
			
			if (el.requestFullscreen) {
			  el.requestFullscreen();
			} else if (el.msRequestFullscreen) {
			  el.msRequestFullscreen();
			} else if (el.mozRequestFullScreen) {
			  el.mozRequestFullScreen();
			} else if (el.webkitRequestFullscreen) {
				el.webkitRequestFullscreen();
			}
		};

	handleCloseAbsenModal = () => {
		this.setState({ absent_code: '' })
	}

	handleCloseAbsenModalQuiz = () => {
		this.setState({ absent_code_quiz: '' })
	}

	
	// count persentase progress course
	hitungPersentase = () => {
		let datas = this.state.data.modules;
		// looping every subs
		// var arr_dt = [];
		// var dt_sub = [];
		const filterDataStatus = datas.map((val, index) => {
		  return val.topics;
		});
		// by module
		var uncompleted=0;
		for (var i = 0; i < filterDataStatus.length; i++) {
		  let cekdata = filterDataStatus[i];
		  let filter_kuis_video = cekdata.filter(   // search data videos/kuis its completed=false
			(vals) =>
			  vals.completed == false &&
			  (vals.resource_type == 1 || vals.resource_type == 4 || vals.title == 'UJIAN PRAKTEK' )
		  );
		  //console.log('cek complete data', filter_kuis_video);
		  

		  if (filter_kuis_video.length > 0) {			
			uncompleted++; // if isset video/kuis false in every modules then increment uncompleted videos
			// let obj = filter_kuis_video;
			// arr_dt = arr_dt.concat(obj);
		  }

		}

		let alldata = datas.length;
		let completed = parseInt(alldata) - parseInt(uncompleted);
		//console.log('cek percent', completed,parseInt(alldata), parseInt(uncompleted));
		let percent_completed = (parseFloat(completed) / parseFloat(alldata)) * 100;
		
		// var roundedPercent = percent_completed.toFixed(0);
		var roundedPercent = percent_completed < 0 ? 0 : percent_completed.toFixed(0);

		var warna = "";
		switch (true) {
			case roundedPercent <= 30:
				warna = "#B22222";
			break;
		  case roundedPercent > 30 && roundedPercent <= 66:
			warna = "#CCCC00";
			break;
		  case roundedPercent > 66 && roundedPercent <= 100:
			warna = "green";
			break;
		//   case roundedPercent >= 100:
		// 	warna = "linear-gradient(71deg, #4caf50, #4caf50,#4caf50)";
		// 	break;
		  default:
			warna = "f7980a";
		}

		// by topics
		const mergedData = filterDataStatus.reduce((acc, module) => acc.concat(module), []);
		let filter = mergedData.filter(   // search data videos/kuis its completed=false
			(vals) => vals.resource_type == 1 || vals.resource_type == 4 || vals.title == 'UJIAN PRAKTEK'
		);
		let filter_true = mergedData.filter(   // search data videos/kuis its completed=false
			(vals) => vals.completed && (vals.resource_type == 1 || vals.resource_type == 4 || vals.title == 'UJIAN PRAKTEK')
		);
		
		const percentFinale = (filter_true.length / filter.length) * 100

		this.setState({
		  progressCourse: {
			completed: roundedPercent, //module
			bgcolor: warna,
			// completed: percentFinale.toFixed(0), //topics
			alldata: alldata,
			countComplete:completed,
			uncompleted: uncompleted,
		  }
		});
	};

	setFocusToPdf = element => {
		// set focus to pdf, so next page button can run without triggering auto scroll
		if(element && document.activeElement !== element) {
			setTimeout(() => {
				element.focus()
			}, 50)
		}
	}

	getResourceObject = (topic, image) => {
		const prefix = '/js/ViewerJS/index.html#'
		const {data} = this.state
		
		if(topic.resource_type !== CourseDetail.TYPE_VIDEO){
			this.state.eventState = null;
		}

		if(topic.resource_type == 3) {
			const element = document.getElementById("viewerJS")

			// start::set focus to pdf except when rating modal popped
				// get rating modal definitions
				const rating_modal_id = 'course_rating_modal'
				const opened_rating_modal = document.querySelector(`#${rating_modal_id}.modal.open`)

				if(opened_rating_modal) {
					opened_rating_modal.focus()

					// listen to event on close button on rating modal
					$(`#${rating_modal_id} #rating-modal-button`).on('click', () => {
						opened_rating_modal.blur()
						
						this.setFocusToPdf(element)
					}) // do the focus function
					
					// listen to event on send button on rating modal
					$(`#${rating_modal_id} .modal-close`).on('click', () => {
						opened_rating_modal.blur()
						
						this.setFocusToPdf(element)
					}) // do the focus function
				} else {
					this.setFocusToPdf(element)
				}
			// end::set focus to pdf except when rating modal popped

			if(element && element.src) {

				//setTimeout(() => {
				//	element.focus()
				//}, 50)

				const element_src = element.src.split('#')[1]

				if(element_src && element_src != topic.resource_url) {
					element.src = ''
	
					setTimeout(() => {
						element.src = `${prefix}${topic.resource_url}`
					}, 50)
				}
			}
		}

		if (!topic || topic.locked) {
			return (
				<div className="center">
					<img src={image} />
				</div>
			);
		}

		const selectedTopicIndex = data.modules.findIndex((module) => {
			// Use findIndex to find the index of the selected topic within module.topics
			return module.topics.findIndex((dataTopic) => dataTopic.uuid === topic.uuid) !== -1;
		});
		
		var resourceType = topic.resource_type;
		// var url = topic.resource_url;
		var url = topic.resource_url;
		const checkUrl = url.split('|')
		let isAutoStart = 1
		if(checkUrl.length > 1){
			isAutoStart = 0
		}
		if(this.state.topic_videoUrl){
			url = this.state.topic_videoUrl
		}
		var secureUrl = topic.resource_secure_url;

		if(typeof data.modules[selectedTopicIndex].topics[0].is_next_day !== 'undefined'
		&& data.modules[selectedTopicIndex].topics[0].is_next_day){
			return(
				<div style={{minHeight:'400px', display:'flex', justifyContent:'center', alignItems:'center'}}>
				<div style={{textAlign:'center', padding:'10px'}}>
					<h3>Mohon Maaf.<br/>Anda baru boleh melanjutkan Sesi berikutnya esok hari.</h3>
				</div>
			</div>)
		}
		if(typeof data.modules[selectedTopicIndex].topics[0].must_verify_prakerja === 'undefined'){
			if (resourceType === CourseDetail.TYPE_VIDEO) {
				//return <ReactJWPlayer playerId='video' playerScript='https://content.jwplatform.com/libraries/PpDAvH51.js' file={url} image={image} />
				//return <ReactHLS style={{backgroundImage: `url(${image})`}} preload="none" id="video" poster={image} ref="video" width="100%" url={url} controls={true} />
				if (
					url !== null &&
					(url.includes("youtube.com") || url.includes("youtu.be"))
				) {
					let videoID;
					url = url
						.replace(/(>|<)/gi, "")
						.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
						if (url[2] !== undefined) {
							videoID = url[2].split(/[^0-9a-z_\-]/i);
						videoID = videoID[0];
					} else {
						videoID = url;
					}
					
					let playondevice;
					if(rdd.isMobile === true){
						playondevice = "yt-video-wrapper-mobile"
					}else{
						playondevice = "yt-video-wrapper"
					}
					return (
						<div className="non-clickable">
							<YouTube
								videoId={videoID}
								id="YTVideo"
								containerClassName= {playondevice}
								opts={{
									height: "390",
									width: "800",
									
									playerVars: {
										autoplay: isAutoStart,
										controls: 0,
										disablekb: 0,
										rel:0,
									}
								}}
								//onReady={this._onReadyVideo}
								onReady={(event) => {
									this._onReadyVideo(event);
									this.disableCaptions(event);
								}}
								onPlay={(event) => {
										this.onMediaAction(event,topic, 1);
	
										this.noteVideoState();
										this.disableCaptions(event);
									}
								}
								onPause={(event) => this.onMediaAction(event,topic, 2)}
								onEnd={(event) => this.onMediaAction(event,topic, 3)}
								onError={() => this.onMediaAction(topic, 4)}
								onStateChange={(evntState) => this.onStateChangeVideo(evntState)}
								ref={(element) => this.youtubePlayer = element}
							/>
						</div>
					);
				} else {
					return (
						<VideoPlayer
							controls={true}
							src={url}
							hideControls={['playbackrates']}
							hidePlaybackRates = {true}
							onPlay={() => this.onMediaAction(this.state.topic, 1)}
							onPause={() => this.onMediaAction(this.state.topic, 2)}
							onEnd={() => this.onMediaAction(this.state.topic, 3)}
							/>
					);
				}
			} else if (resourceType === CourseDetail.TYPE_AUDIO) {
				return (
					<ReactPlayer
						style={{ background: `url(${image})` }}
						preload="none"
						id="audio"
						poster={image}
						ref="audio"
						width="100%"
						url={url}
						controls={true}
						onEnded={() => this.onMediaAction(this.state.topic, 3)}
						onError={() => this.onMediaAction(this.state.topic, 4)}
						onPause={() => this.onMediaAction(this.state.topic, 2)}
						onPlay={() => this.onMediaAction(this.state.topic, 1)}
					/>
				);
			} else if (resourceType === CourseDetail.TYPE_PDF) {
				return (
					<div>
						{/* <iframe id="viewerJS" src={`/js/ViewerJS/index.html#${url}`} className="pdf" frameBorder="0" allowFullScreen onChange={() => this.hitungPersentase()} onClick={() => this.hitungPersentase()}></iframe> */}
						<iframe id="viewerJS" src={`/js/ViewerJS/index.html#${url}`} className="pdf" frameBorder="0" allowFullScreen></iframe>
					</div>
				);
			} else if (resourceType === CourseDetail.TYPE_QUIZ) {
				if(this.state.is_uprak){
					var quizText =
						"Anda akan memulai kuis ini sebagai syarat untuk melanjutkan ke " +
						trans.session +
						" selanjutnya. Uji pemahaman Anda secara jujur dan selamat mengerjakan!";
					} else {
					var quizText =
						"Anda akan memulai kuis ini sebagai syarat untuk melanjutkan ke " +
						trans.chapter +
						" selanjutnya. Uji pemahaman Anda secara jujur dan selamat mengerjakan!";
				}
				
				if (topic.title.toLowerCase() == "ujian akhir/post test") {
					if(this.state.is_uprak){
						quizText = (
							<div>
								Anda akan memulai post test/ujian ini sebagai syarat untuk mengikuti UJIAN PRAKTEK.<br />Silahkan uji Pemahaman Anda secara jujur dan selamat mengerjakan!
							</div>
						);
					} else {
						quizText = (
							<div>
								Anda akan memulai post test/ujian ini sebagai syarat untuk mendapatkan SERITIFIKAT PENYELESAIAN kelas dan SERTIFIKAT KELULUSAN kelas.<br />Silahkan uji Pemahaman Anda secara jujur dan selamat mengerjakan!
							</div>
						);
					}
				}
				
				var quizData = store.get(`quiz_${topic.uuid}`);
				var lastAttempt = topic.last_accessed;
				var retakeQuizBtn = "";
				var quizResultBtn = (
					<Link
						to={`/quiz/result/${topic.uuid}`}
						className="btn full-s capitalize"
						onChange={() => this.hitungPersentase()}
						onClick={() => this.hitungPersentase()}
					>
						Lihat Hasil
					</Link>
				);
	
				var completed = topic.completed;
	
				if (quizData) {
	
					let quizTitle = "Kuis"
					let topicTitle = topic.title.toLowerCase()
	
					if( topicTitle == "ujian akhir/post test" ){
						quizTitle = "Ujian Akhir/Post Test"
					}
					else if( topicTitle == "wajib melengkapi praujian" ){
						quizTitle = "Pre Test"
					}
	
					quizText =
						quizTitle + " Anda sebelumnya belum disubmit. Silakan klik button di bawah untuk melanjutkan sesi " + quizTitle + " sebelumnya";
	
					retakeQuizBtn = (
						<Link to={`/quiz/${topic.uuid}`} className="btn full-s capitalize">
							Lanjut {quizTitle}
						</Link>
					);
					quizResultBtn = "";
				} else if (lastAttempt) {
					// @fixme it should be lastAttempt
					if(topic.title.toLowerCase() == "ujian akhir/post test" || topic.title.toLowerCase() == "wajib melengkapi praujian" ){
						
						let quizTitle = "Ujian Akhir/Post Test"
						if(topic.title.toLowerCase() == "wajib melengkapi praujian"){
							quizTitle = "Pre Test"
						}
						
						retakeQuizBtn = (
							<Link
								to={`/quiz/${topic.uuid}`}
								className="btn full-s capitalize btn-outline"
							>
								Ulang {quizTitle}
							</Link>
						);
						quizText =
							"Anda telah menyelesaikan " + quizTitle + " ini pada tanggal " +
							FormatDateIndo(lastAttempt) +
							". Anda bisa melihat hasil  " + quizTitle + "  Anda sebelumnya dengan menekan tombol di bawah.";
						if (completed) {
							let lastModule = this.state.data.modules[
								this.state.data.modules.length - 1
							];
							let lastTopic = lastModule.topics[lastModule.topics.length - 1];
		
							if (topic.uuid != lastTopic.uuid || this.state.data.completed) {
								retakeQuizBtn = "";
							}
						} else {
							quizText +=
								" Jika Anda belum lulus, Anda dapat mengulangi " + quizTitle + " ini sampai Anda lulus";
						}
					}else{
						retakeQuizBtn = (
							<Link
								to={`/quiz/${topic.uuid}`}
								className="btn full-s capitalize btn-outline"
							>
								Ulang Kuis
							</Link>
						);
						quizText =
							"Anda telah menyelesaikan kuis ini pada tanggal " +
							FormatDateIndo(lastAttempt) +
							". Anda bisa melihat hasil kuis Anda sebelumnya dengan menekan tombol di bawah.";
						if (completed) {
							let lastModule = this.state.data.modules[
								this.state.data.modules.length - 1
							];
							let lastTopic = lastModule.topics[lastModule.topics.length - 1];
		
							if (topic.uuid != lastTopic.uuid || this.state.data.completed) {
								retakeQuizBtn = "";
							}
						} else {
							quizText +=
								" Jika Anda belum lulus, Anda dapat mengulangi kuis ini sampai Anda lulus";
						}
					}
				} else {
					retakeQuizBtn = (
						<Link to={`/quiz/${topic.uuid}`} className="btn full-s capitalize">
							Mulai Kuis
						</Link>
					);
					quizResultBtn = "";
				}
	
				var messagePesanHold = "";
	
				let webinar_quiz = this.state.kuis_webinar.find(kuis => kuis.uuid == topic.uuid);
				if(typeof webinar_quiz != 'undefined') {
					webinar_quiz = Object.keys(webinar_quiz).length > 0 ? true : false;
					if(webinar_quiz == true){ //=== kuis webinar
						if(this.state.status_webinar==false){ //=== absen webinar
							retakeQuizBtn = (
								<Modal
									trigger={
										<button className="btn bg-primary">Absen Kehadiran Webinar</button>
									}
								>
									<div className="center">
										<div>
											<h5>Masukkan Kode Absensi yang Kamu Dapatkan pada Saat Webinar</h5>
										</div>
										<div className="modal-content">
											<div className="input-field text-left">
												<input
													name="absent-code"
													type="text"
													placeholder="Kode Absensi"
													onChange={this.handleAbsentCodeChange}
													value={this.state.absent_code}
													autoComplete="off"
												/>
												<div className="helper-text text-left font-orange-red inline-block font-tiny">
													{this.state.errorAbsentCode}
												</div>
											</div>
										</div>
										<div className="d-flex-jc-center">
											<button className="btn btn-small delete-btn mr-xs" disabled={this.state.absent_loading ? true : false} onClick={() => this.submitAbsentCode()}>Submit</button>
											<button id="kode-absensi-modal-close" onClick={this.handleCloseAbsenModal} className="btn btn-small delete-btn bg-danger modal-close" disabled={this.state.absent_loading ? true : false}>Batal</button>
										</div>
									</div>
								</Modal>
							);
							quizResultBtn = "";
							messagePesanHold = (<div>Anda dapat mengerjakan Kuis Webinar setelah menekan tombol "Absen Kehadiran Webinar". Absen Kehadiran Webinar dibuktikan dengan cara memasukkan Kode/Pin Absen yang dibagikan di akhir sesi Webinar.</div>);
							quizText = "";
						}
					}
				}
				
				let absent_quiz = this.state.kuis_absensi.find(kuis => kuis.uuid == topic.uuid);
				if(typeof absent_quiz != 'undefined' && !absent_quiz.hasAbsent) {
					absent_quiz = Object.keys(absent_quiz).length > 0 ? true : false;
					if(absent_quiz == true){ //=== kuis webinar
						if(this.state.status_webinar==false){ //=== absen webinar
							retakeQuizBtn = (
								<Modal
									trigger={
										<button className="btn bg-primary">Absen Kehadiran</button>
									}
								>
									<div className="center">
										<div>
											<h5>Masukkan Kode Absensi yang Kamu Dapatkan pada Saat Sesi Kelas</h5>
										</div>
										<div className="modal-content">
											<div className="input-field text-left">
												<input
													name="absent-code"
													type="text"
													placeholder="Kode Absensi"
													onChange={this.handleAbsentCodeChangeQuiz}
													value={this.state.absent_code_quiz}
													autoComplete="off"
												/>
												<div className="helper-text text-left font-orange-red inline-block font-tiny">
													{this.state.errorAbsentCodeQuiz}
												</div>
											</div>
										</div>
										<div className="d-flex-jc-center">
											<button className="btn btn-small delete-btn mr-xs" disabled={this.state.absent_loading ? true : false} onClick={() => this.submitAbsentCodeQuiz(absent_quiz, topic.uuid)}>Submit</button>
											<button id="kode-absensi-modal-close" onClick={this.handleCloseAbsenModalQuiz} className="btn btn-small delete-btn bg-danger modal-close" disabled={this.state.absent_loading ? true : false}>Batal</button>
										</div>
									</div>
								</Modal>
							);
							quizResultBtn = "";
							messagePesanHold = (<div>Anda dapat mengerjakan Kuis setelah menekan tombol "Absen Kehadiran". Absen Kehadiran dibuktikan dengan cara memasukkan Kode/Pin Absen yang dibagikan di akhir sesi.</div>);
							quizText = "";
						}
					}
				}
				
				return (
					<div className="pad-m pad-l center">
						<h4>{topic.title}</h4>
						{/* <h5>{topic.module_title}</h5> */}
						<div className="pad-l">
							<img src={BASE_URL + "/img/quiz-reminder.png"} />
						</div>
						<p className="h5 font-light">Jumlah Pertanyaan : {topic.question_count}</p>
						<p className="h5 font-light">Batas Minimum Nilai : {topic.question_weight}</p>
						<p className="h5 font-light mb-m">{quizText}</p>
						<p className="h5 font-light mb-m" style={{color: "red"}}>{messagePesanHold}</p>
						{retakeQuizBtn} &nbsp; {quizResultBtn}
					</div>
				);
			} else if(resourceType === CourseDetail.TYPE_GAME){
				return (
					<div>
						{
							typeof this.state.gameQuiz_data.gameType != 'undefined' && this.state.gameQuiz_data.gameType === 'multiplechoice' ? (
								<MultipleChoiceGame isTrue={this.state.isPopUpQuizTrue} notifMessage={this.state.notifPopUpQuizMessage} question={this.state.gameQuiz_data.questionList} answer={this.state.gameQuiz_data.answerList} updateData={(istrue)=>this.updateQuiz(istrue)} uuid={this.state.topic.uuid} nextChapter={()=>this.nextChapter(true, true)}/>
								) : typeof this.state.gameQuiz_data.gameType != 'undefined' && this.state.gameQuiz_data.gameType === 'searchword' ? (
									<SearchWordGame answer={this.state.gameQuiz_data.answerList[0].name} question={this.state.gameQuiz_data.questionList[0].question}/>
								)
								: typeof this.state.gameQuiz_data.gameType != 'undefined' && this.state.gameQuiz_data.gameType === 'matchingword' && (
									<WordMatchingGame question={this.state.gameQuiz_data.questionList} answer={this.state.gameQuiz_data.answerList}/>
								)
						}
					</div>
				);
			}
	
		}else{
			const verifClick = () => {
				const API_VERMUK = API_BASE_URL + '/vermuk';
				const param = {
					voucher_code : data.voucher_code_used,
					sequence : data.modules[selectedTopicIndex].topics[0].must_verify_prakerja
				}
				this.setState({vermuk_loader : true})
				$.post(API_VERMUK, param).then(response => {
					window.location.assign(response.payload.url)
					this.setState({vermuk_loader : false})
				}).catch(error => {
					this.setState({vermuk_loader : false})
					notify.show(error.responseJSON.message, "warning", 5000);
				})
			}
				return(
					<div style={{minHeight:'400px', display:'flex', justifyContent:'center', alignItems:'center'}}>
					<div style={{textAlign:'center', padding:'10px'}}>
						<h3>Anda belum melakukan proses <i><b>Verifikasi Wajah</b></i>, silakan klik tombol di bawah</h3>
						<Button style={{position: 'relative'}} disabled={this.state.vermuk_loader ? true : false} onClick={verifClick}> { this.state.vermuk_loader && <div className="vloader" style={{top:'25%', left:'43%'}}></div>} Verifikasi Wajah</Button>
					</div>
				</div>
			)
		}
	};

	getFloatingCourseBar = data => {
		var isMobile = this.state.width && this.state.width < 800;
		let hasCashback =
			CheckAuth().account_type == UserConstants.PAYTREN_ACCOUNT &&
			data.user_cashback > 0;
		let isEnrolled =
			data.enrolled &&
			(CheckAuth().account_type != UserConstants.PAYTREN_ACCOUNT ||
				data.price == 0);
		const paddedStyle = {
			paddingTop: "0.5rem",
			paddingBottom: "1rem",
			marginBottom: "-1rem"
		};
		const marginTop = { marginTop: "3rem" };
		const is_businessman = CheckAuth().is_businessman === 1;

		if (data.enrolled && !data.completed) {
			return "";
		}

		// DUMP DATA

		return (
			<div>
				<div
					className="bg-white pad-m row mb-0 border-bottom shadowed"
					id="floating-course-bar"
				>
					<div className="h4 font-narrow inner-course-bar">
						<div className="mb-0" id="price-section">
							{/* <Col l={12} m={12} s={12} className="enroll-section"> */}
								{!data.enrolled && (
									<div>
										<div className="text-right">
											<Row className="align-items-center digital-platform-wrapper">
												<div>
													{/* desktop */}
													{/* <div className="text-left d-flex digital-platform desktop">
														<a href="https://www.tokopedia.com/kartu-prakerja/partner/geti-incubator" target="_blank">
															<img src={ require("../../assets/digital-platform-icon/tokopedia.png") } className="digital-platform-icon" />
														</a>
														<a href="https://pijarmahir.id/institution-partner/776216?page=1&limit=30" target="_blank">
															<img src={ require("../../assets/digital-platform-icon/pijar.png") } className="digital-platform-icon" />
														</a>
														<a href="https://m.bukalapak.com/kartu-prakerja/pencarian?from=omnisearch&from_keyword_history=false&search_source=omnisearch_keyword&source=navbar&keyword=geti%20incubator" target="_blank">
															<img src={ require("../../assets/digital-platform-icon/buka-lapak.png") } className="digital-platform-icon" />
														</a>
														<a href="https://pintar.co/kartuprakerja/geti" target="_blank">
															<img src={ require("../../assets/digital-platform-icon/pintardotco.png") } className="digital-platform-icon" />
														</a>
														<a href="https://prakerja.karier.mu/mitra/geti-incubator" target="_blank">
															<img src={ require("../../assets/digital-platform-icon/karier.mu.png") } className="digital-platform-icon" />
														</a>
													</div> */}
													{/* tablet */}
													{/* <div className="text-left d-flex digital-platform tablet">
														<div>
															<a href="https://www.tokopedia.com/kartu-prakerja/partner/geti-incubator" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/tokopedia.png") } className="digital-platform-icon" />
															</a>
															<a href="https://pijarmahir.id/institution-partner/776216?page=1&limit=30" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/pijar.png") } className="digital-platform-icon" />
															</a>
														</div>
														<div>
															<a href="https://m.bukalapak.com/kartu-prakerja/pencarian?from=omnisearch&from_keyword_history=false&search_source=omnisearch_keyword&source=navbar&keyword=geti%20incubator" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/buka-lapak.png") } className="digital-platform-icon" />
															</a>
															
														</div>
														<div>
															<a href="https://pintar.co/kartuprakerja/geti" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/pintardotco.png") } className="digital-platform-icon" />
															</a>
															<a href="https://prakerja.karier.mu/mitra/geti-incubator" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/karier.mu.png") } className="digital-platform-icon" />
															</a>
														</div>
													</div> */}
													{/* mobile */}
													{/* <div className="text-left d-block digital-platform mobile">
														<div className="d-flex">
															
															<a href="https://www.tokopedia.com/kartu-prakerja/partner/geti-incubator" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/tokopedia.png") } className="digital-platform-icon" />
															</a>
															<a href="https://pijarmahir.id/institution-partner/776216?page=1&limit=30" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/pijar.png") } className="digital-platform-icon" />
															</a>
														</div>
														<div className="d-flex">
															<a href="https://m.bukalapak.com/kartu-prakerja/pencarian?from=omnisearch&from_keyword_history=false&search_source=omnisearch_keyword&source=navbar&keyword=geti%20incubator" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/buka-lapak.png") } className="digital-platform-icon" />
															</a>
															<a href="https://pintar.co/kartuprakerja/geti" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/pintardotco.png") } className="digital-platform-icon" />
															</a>
															<a href="https://prakerja.karier.mu/mitra/geti-incubator" target="_blank">
																<img src={ require("../../assets/digital-platform-icon/karier.mu.png") } className="digital-platform-icon" />
															</a>
														</div>
													</div> */}
												</div>
												<div className="d-flex price-wrapper">
													<div>
														<div
														className="price-section font-heavy font-orange"
														style={{ marginTop: "-0.2rem", verticalAlign:'bottom', display: 'inline-block' }}
														>
														<div>
															<div id="non-partner-floating-price" style={{textAlign:'left'}}>
																<h6 className="price-type" id="floating-price-type">
																	Harga
																</h6>
																<span className="floating-course-price">
																	{data.price > 0 && (
																		<span>{FormatPrice(data.price)}</span>
																	)}
																	{data.price === 0 && <span>GRATIS</span>}
																</span>
															</div>
														</div>
														</div>
													</div>
													<div className="buy-btn desktop">
														<BuyCourseButton
														onEnroll={this.handleEnroll}
														data={data}
														onRedeem={this.handleRedeem}
														onPayment={this.handlePayment}
														errorMessage={this.state.errorMessage}
														requiredCourse={data.required_course}
														/>
													</div>
												</div>
											</Row>
											<Row>
												<div className="buy-btn mobile text-center mt-s">
													<BuyCourseButton
													onEnroll={this.handleEnroll}
													data={data}
													onRedeem={this.handleRedeem}
													onPayment={this.handlePayment}
													errorMessage={this.state.errorMessage}
													requiredCourse={data.required_course}
													/>
												</div>
											</Row>
										</div>
									</div>
								)}
								{( (data.enrolled && data.completed && !this.state.is_uprak) 
								|| (data.enrolled && this.state.is_uprak && this.state.uprak.is_passed != 0))
								&& (
									<Row>
										<Col
											l={12}
											m={12}
											s={12}
											className="valign-wrapper right"
											id="floating-buttons"
										>
											{!data.has_reviewed && (
												<div>
													<a
														className="btn"
														// href="#course_rating_modal"
														id="give-rating-button"
														onClick={() =>
															$("#course_rating_button").trigger("click")
														}
													>
														<span className="hide-on-small-only">Tulis</span>{" "}
														Review
													</a>
												</div>
											)}
											{data.has_reviewed && data.user_rating && (
												<div id="user-course-rating-div">
													<span
														id="user-course-rating-head"
														className="font-medium"
													>
														Rating Darimu
													</span>
													<br />
													<StarRatings
														rating={data.user_rating}
														starDimension={"1.25rem"}
														starRatedColor={"#f2c94c"}
														starSpacing={"1px"}
													/>
												</div>
											)}
											{
												!this.state.refjournalHasAnswered && this.state.comments_refJournal.length !== 0 ? (
													<div className="ml-m mr-m">
														<a
															className="btn"
															// href="#course_rating_modal"
															onClick={() =>{
																	$("#refJournal_rating_button").trigger("click")
																	this.setState({isRefJournalOpen: true})
																}
															}
														>
															<span className="hide-on-small-only">Reflective</span>{" "}
															Journal
														</a>
													</div>
												):null
											}
											<div data-tip={data.has_reviewed ? 'Lihat nilai dan sertifikat' : 'Silakan tulis review terlebih dahulu'}>
												<Link
													to={data.has_reviewed ? `/course/${data.slug}/recap` : '#'}
													className={"btn modal-close"}
													disabled={!data.has_reviewed}
													id="floating-recap-button"
												>
													Rekap Nilai
													</Link>
												<ReactTooltip place="top" type="info" effect="solid" />
											</div>
										</Col>
									</Row>
								)}
							{/* </Col> */}
						</div>
					</div>
				</div>
			</div>
		);
	};

	getRedeemCouponModal = () => {
		return (
			<form
				autoComplete="off"
				onSubmit={this.handleEnroll}
				className="mb-0 row"
			>
				<img className="mb-s" src={BASE_URL + "/img/logo-paytren-black.png"} />
				<h5>Beli Menggunakan Kupon</h5>

				<div className="mb-s">
					Dengan menekan tombol “Redeem”, Anda akan langsung terdaftar pada{" "}
					{trans.course} ini.
				</div>

				<Input id="coupon_code" label="Masukkan Kode Kupon" s={12} required />

				<Col s={12} className="error-msg font-red strong mnt-s">
					{this.state.errorMessage}
				</Col>

				<Input
					onChange={this.handlePinChange}
					onKeyPress={this.handleTypePin}
					id="pin"
					maxLength="6"
					type="password"
					pattern="[0-9]{6}"
					s={12}
					value="000000"
					required
					disabled
					hidden
				/>

				<a
					className="link strong"
					data-tip={`Kupon berisi kode yang dapat ditukarkan dengan ${trans.course_item}. Satu kupon hanya dapat ditukar dengan 1 ${trans.course_item} dan tidak dapat digunakan kembali.`}
				>
					Apa itu kupon ?
				</a>
				<ReactTooltip place="right" />
				<br />
				<br />
				{/*super.getLoading("loading")*/}
				<Button id="enroll-btn" className="full" waves="light">
					REDEEM
				</Button>
			</form>
		);
	};

	ModuleComponent = (data,activeTopic) => {
		let index_completed = 0;
		this.tpmSorting(data.modules)
		data = this.state.data
		
		const selectedTopicIndex = data.modules.findIndex((module) => {
			// Use findIndex to find the index of the selected topic within module.topics
			return module.topics.findIndex((topic) => topic.uuid === activeTopic.uuid) !== -1;
		});
		const { isFirstScroll } = this.state;
		return (
			<Collapsible className="modules-collapsible">
				{data.modules.map((module, i) => (
					<CollapsibleItem
						key={i}
						header={module.title}
						icon="keyboard_arrow_right" 
						expanded={isFirstScroll ? i === selectedTopicIndex : false}
					>
						<Collection>
							{module.topics.map((topic, j) => {
								topic.completed = (topic.resource_length=="WEBINAR" && this.state.status_webinar==true)? true : topic.completed;
								topic.resource_length = (topic.resource_length=="WEBINAR" && this.state.status_webinar==true)? '' : topic.resource_length;
								// 
								if(topic.completed){ //index complated terakhir 
									index_completed = j+1;
								}

								// || topic.resource_type == CourseDetail.TYPE_PDF

								if(j==0 && topic.completed==false ){
									index_completed = 0;
								}

								if(j==index_completed && topic.resource_type == CourseDetail.TYPE_PDF){
									index_completed = j+1;
								}
								

								return <CollectionItem
									className={activeTopic.uuid === topic.uuid ? "active" : ""}
									data-modulekey={i}
									data-topickey={j}
									data-locked={this.checkUprakLocked(topic,j,index_completed)}
									onClick={this.handleClick.bind(this, i, j, this.checkUprakLocked(topic,j,index_completed), topic.resource_type, topic.title, topic)}
									href={this.checkUprakLocked(topic,j,index_completed) ? "#" : "#" + topic.uuid}
									key={j}
								>
									{this.getResourceIcon(topic)}
									<span
										className="font-light"
										style={
											topic.selected
												? { color: "#134b95" }
												: topic.completed
													? { color: "#F0BC5E" }
													: {}
										}
									>
										{topic.title == 'UJIAN PRAKTEK'? 'Instruksi Unjuk Keterampilan' : topic.title }
									</span>
									<div className="valign-wrapper">
										<Icon tiny>{this.checkUprakLocked(topic,j,index_completed) && "lock"}</Icon>&nbsp;
										<span className="topic-length">
											{topic.resource_length || "00:00"}
										</span>
									</div>
								</CollectionItem>
							})}
						</Collection>
					</CollapsibleItem>
				))}
			</Collapsible>
		);
	} 

	render() {
		var data = this.state.data;
		var activeTopic = this.state.topic;
		var isMobile = this.state.width && this.state.width < 800;

		let rating_specs = [
			{ topic: "rating", name: "rating", item: "modul" }
		];

		let nama = store.get('userdata') ? store.get('userdata').nama : 'Nama sesuai KTP';
		let comment_rating_specs = [
			{
				title: "Punya saran/ulasan untuk pelatihan ini?",
				description: "",
				placeholder: "Masukkan darimu menjadi bahan evaluasi kami",
				name: "user_comment"
			},
			{
				title: "Nama Lengkap",
				description: "Sesuai nama di KTP untuk ditampilkan di sertifikat",
				placeholder: nama,
				name: "user_name"
			}
		];

		const updateRefJournalBtn = () => {
			this.setState({refjournalHasAnswered : true})
		}

		if (this.state.session_expired || (CheckAuth() === false && this.state.enrolling)) {
			return <Redirect to={"/login?redirect=" + window.location.pathname} />;
		}

		if (!data) {
			return super.render();
		}

		let shareUrl = window.location.origin + `/course.php?uuid=${data.uuid}`;
		let shareContent = `${trans.course} ${data.title} oleh ${data.instructor}`;
		let hasCashback =
			CheckAuth().account_type == UserConstants.PAYTREN_ACCOUNT &&
			data.user_cashback > 0;
		let isEnrolled =
			data.enrolled &&
			(CheckAuth().account_type != UserConstants.PAYTREN_ACCOUNT ||
				data.price == 0);

		const { FacebookShareButton } = ShareButtons;

		// move ujian praktek to the bottom list
		let modules = data.modules[data.modules.length - 1];

		if(typeof modules != 'undefined' && modules.topics) {
			var last_topics = data.modules[data.modules.length - 1].topics;
			var up = 'UJIAN PRAKTEK';

			if(last_topics.find(topic => topic.title == up)) {
				let ujian_praktek = last_topics.find(topic => topic.title == up);

				if(last_topics[last_topics.length - 1].title != up) {
					last_topics = last_topics.filter(topic => !(topic.title == up));
				}
				
				if(typeof last_topics[last_topics.length - 1] != 'undefined') {
					if(last_topics[last_topics.length - 1].title != up) {
						last_topics[last_topics.length] = ujian_praktek;
					}
				}
		
				data.modules[data.modules.length - 1].topics = last_topics;
			}
		}
		// end move

		let btnPausePlayColors=this.state.isPlaying==1?'#ff685d':'#34b9f6';
		return (
			<div>
				{/* start::ujian praktek notif modal */}
					{/* start::success upload notif modal */}
					<Modal
						trigger={
							<span id="success-upload-notif-button" className="hide">
								Success Upload Notif Trigger
							</span>
						}
						id="success-upload-notif-modal"
					>
						<div className="center">
							<div>
								<h5>Upload File Berhasil!</h5>
							</div>
							<div className="d-flex-jc-center">
								<button className="btn btn-small delete-btn bg-success modal-close">Oke</button>
							</div>
						</div>
					</Modal>
					{/* end::success upload notif modal */}

					{/* start::failed upload notif modal */}
					<Modal
						trigger={
							<span id="failed-upload-notif-button" className="hide">
								Failed Upload Notif Trigger
							</span>
						}
						id="failed-upload-notif-modal"
						style={{ 
							overflow: 'hidden',
							maxHeight: 'unset'
						}}
					>
						<div className="center">
							<div>
								<h5 className="text-danger">Upload File Gagal!</h5>
								<p>{this.state.errorUpload}</p>
							</div>
							<div className="d-flex-jc-center">
								{/* <button 
									className="btn btn-small delete-btn bg-success modal-close mr-xs"
									onClick={this.handleReuploadUjianPraktek}
								>Upload Ulang</button> */}
								<button className="btn btn-small delete-btn bg-primary modal-close" onClick={() => this.setState({errorUpload:''})}>OK</button>
							</div>
						</div>
					</Modal>
					{/* end::failed upload notif modal */}

					{/* start::success delete notif modal */}
					<Modal
						trigger={
							<span id="success-delete-notif-button" className="hide">
								Success Delete Notif Trigger
							</span>
						}
						id="success-delete-notif-modal"
					>
						<div className="center">
							<div>
								<h5>Hapus File Berhasil!</h5>
							</div>
							<div className="d-flex-jc-center">
								<button className="btn btn-small delete-btn bg-success modal-close">Oke</button>
							</div>
						</div>
					</Modal>
					{/* end::success delete notif modal */}

					{/* start::custom notif modal */}
					<Modal
						trigger={
							<span id="custom-notif-button" className="hide">
								custom trigger
							</span>
						}
						id="custom-notif-modal"
					>
						{ this.state.custom_modal.content_html }
					</Modal>
					{/* end::custom notif modal */}
				{/* end::ujian praktek notif modal */}

				<RatingModal
					header="Beri Rating Kuliah Ini"
					rating_specs={rating_specs}
					comment_specs={comment_rating_specs}
					modal_name="course_rating"
					voucher_used={data.voucher_code_used}
					is_open={
						!this.state.is_load_uprak && (store.get("review_modul") && store.get("review_modul") === this.state.uuid) || this.state.is_uprak ? this.state.is_review : data.ask_to_review
					}
					callback={this.handleLoadData}
					api_url={API_COURSE_BASE_URL + this.state.data.uuid + "/review"}
				/>
				<RefJournal
					header="Bagikan pengalamanmu setelah mengikuti pelatihan ini!"
					comment_specs={this.state.comments_refJournal}
					modal_name="refJournal_rating"
					is_open={this.state.isRefJournalOpen}
					callback={updateRefJournalBtn}
					api_url={API_BASE_URL + "/reflective_journal"}
				/>
				<div className="container narrow digital-platform-narrow" style={{minWidth: '100%'}}>
					<div className="bg-white pad-m row mb-0 border-bottom shadowed">
						<button onClick={()=>this.hitungPersentase()} id="btnTriggerProgressLoad" style={{display:'none'}}>run</button>
						<h5 id="top-course-title">{data.title}</h5>
						{/* <h6>{data.instructor}</h6> */}
						{
							this.state.link_materi ? 
								<a onClick={() => this.handleLinkMateri()}>
									<Button style={{ marginBottom: "10px" }} className="btn-pa">Bahan Bacaan</Button>
								</a>
							: 
								""
						}
						{/* <p><button onClick={()=>this.showCompleteModel()}>OKE</button></p> */}
						{/* <p><button onClick={()=>this.onFocus()}>OKE</button></p> */}
						{/* <p>{this.state.countDownTimerPause}</p> */}

						{
								this.state.data.enrolled?
								<span>
								<ProgressBar
									bgcolor={this.state.progressCourse.bgcolor}
									completed={this.state.progressCourse.completed}
								/>
								</span>:''
						}

						{
							this.state.topic.resource_type==1 && this.state.eventState !=null && typeof this.state.topic.must_verify_prakerja === 'undefined' ?
							<div style={{float:'right',marginBottom:'-18px',marginTop:'6px'}}>
								{
									typeof this.state.topic.popup_quiz_answered !== "undefined" ?
										!this.state.topic.popup_quiz_answered && ( this.state.isPlaying === 3 || this.state.topic.video_has_watched 
											|| this.state.is_dummy) ? (
											<button id="btnFullScreen"  style={{marginRight: '10px',background:'#134b95'}} onClick={()=> this.toggleGameQuiz(this.state.topic.uuid)}>
												<span>Pop Up Kuis</span>
											</button>
										):""
									: ""
								}
								<button id="btnFullScreen"  style={{marginRight: '10px',background:'green'}} onClick={()=> this.toggleFullScreen()}>
									<span>Fullscreen</span>
									<span className="material-icons icon-image-preview">fullscreen</span>
								</button>
								{ !this.state.nextChapter ?
									(
										!this.state.videoCompleted ? 
										(
											<button id="btnplaypause"  style={{background:`${btnPausePlayColors}`}} onClick={()=>this.PlayPauseVideo()}>
												{this.state.isPlaying==1?<span>pause</span>:<span>play</span>}
												{this.state.isPlaying==1?<span className="material-icons icon-image-preview">pause</span>:<span className="material-icons icon-image-preview">play_arrow</span>} 
											</button>
										) :
										(
											<button id="btnplaypause"  style={{background:`${btnPausePlayColors}`}} onClick={()=>this.PlayPauseVideo()}>
												<span>replay</span>
												<span className="material-icons icon-image-preview">play_arrow</span>
											</button>
										)
									)
								:
									typeof this.state.topic.popup_quiz_answered === 'undefined' ?
									(
										<button id="btnplaypause"  style={{background:`${btnPausePlayColors}`}} onClick={()=>this.nextChapter(true)}>
											<span>next</span>
											{this.state.isPlaying==1?<span className="material-icons icon-image-preview">pause</span>:<span className="material-icons icon-image-preview">play_arrow</span>} 
											</button>
									):(
										!this.state.videoCompleted ? 
										(
											<button id="btnplaypause"  style={{background:`${btnPausePlayColors}`}} onClick={()=>this.PlayPauseVideo()}>
												{this.state.isPlaying==1?<span>pause</span>:<span>play</span>}
												{this.state.isPlaying==1?<span className="material-icons icon-image-preview">pause</span>:<span className="material-icons icon-image-preview">play_arrow</span>} 
											</button>
										) :
										(
											<button id="btnplaypause"  style={{background:`${btnPausePlayColors}`}} onClick={()=>this.PlayPauseVideo()}>
												<span>replay</span>
												<span className="material-icons icon-image-preview">play_arrow</span>
											</button>
										)
									)
								}
							</div>
							:''
						}
					</div>
					{this.getFloatingCourseBar(data)}
					{data.locked && !this.state.alert_seen && (
						<div className="bg-orange font-white pad-m valign-wrapper">
							<div className="full">
								<span>
									Maaf, untuk melanjutkan {trans.course} ini Anda harus
									menyelesaikan{" "}
									<Link
										className="link strong"
										to={`/course/${data.required_course.uuid}`}
									>
										syarat {trans.course_item}{" "}
									</Link>{" "}
									terlebih dahulu
								</span>
							</div>
							<a onClick={this.handleCloseAlert} className="right">
								<Icon small>clear</Icon>
							</a>
						</div>
					)}
					<div className="row bg-white mb-0 shadowed" id="course-body">
						
						<div
							className={
								isMobile
									? "col s12 border-right pb-m"
									: "col s8 border-right pb-m"
							}
						>
							{
								(this.state.uprak.is_passed == null || this.state.topic.title != 'UJIAN PRAKTEK') 
								? 
									(this.state.uprak_tpm.score == null && this.state.topic.title == 'TUGAS PRAKTIK MANDIRI') 
									? 
										(this.getResourceObject(activeTopic, data.thumbnail)) 
									: 
										(this.state.topic.title != 'TUGAS PRAKTIK MANDIRI')
										?
											(this.getResourceObject(activeTopic, data.thumbnail)) 
										:
											null
								: 
									null
							}

							{this.state.uploaded.length > 0 && this.state.topic.title == "UJIAN PRAKTEK" && this.state.uprak.is_passed == null ? (
								<div>
									<h6 className="pl-s font-weight-bold">Kamu dapat mengupload <span className="text-warning">{this.state.uploaded.length || 0}/{this.state.uprak.max_uploadfile}</span> file</h6>
									<hr />
									<table>
										<tr>
											<th>Nama File</th>
											<th>Status</th>
											<th></th>
										</tr>
										{(this.state.uploaded.map((item,index) => {
											return (
												<tr key={index}>
													<td>
														{
															isMobile ? (
																<h6>{this.renderFileName(item.file_name, 'mobile')}</h6>
																):(
																	<h6>{this.renderFileName(item.file_name, 'web')}</h6>
															)
														}
													</td>
													<td>
														{item.is_checked == true && item.is_passed == true && (
															<h6 className="text-success">
																File ini lulus pengecekan.
															</h6>
														)}

														{item.is_checked == true && item.is_passed == false && (
															<h6 className="text-danger">
																{item.failed_reason || ''}
															</h6>
														)}

														{item.is_checked == false  && (
															<h6 className="text-warning">
																File ini sedang dalam proses pengecekan.
															</h6>
														)}
													</td>
													<td>
													{item.is_passed == false || item.is_passed == null ? (
													<Modal
														trigger={
															<button className="btn btn-small delete-btn bg-danger">Hapus</button>
														}
													>
														<div className="center">
															<div>
																<h5>Apakah Anda yakin ingin menghapus file ini?</h5>
															</div>
															<div className="d-flex-jc-center">
																<button onClick={() => this.deleteFile(item.id)} className="btn btn-small delete-btn mr-xs modal-close">Ya</button>
																<button className="btn btn-small delete-btn bg-danger modal-close">Batal</button>
															</div>
														</div>
														</Modal>
													) : null}
													</td>
												</tr>
											)
										}))}
									</table>
								</div>
							) :""}

							{this.state.topic.title == "UJIAN PRAKTEK" && this.state.upload_uprak == false && this.state.uprak.max_file == false && this.state.uprak.is_passed == null && (
								this.renderUploadButton(activeTopic)
							)}

							{this.state.topic.title == "UJIAN PRAKTEK" && this.state.upload_uprak == true && (
								<div className="wrapper-form-uprak">
									<div>
										<div className="upload-uprak-loader"></div>
										<div className="pt-s mb-xss text-center">Sedang mengupload....
										</div>
									</div>
								</div>
							)}

							{/* {this.state.topic.title == "UJIAN PRAKTEK" && this.state.upload_uprak == false && (
								this.renderRichTextBox()
							)} */}


							{this.state.topic.title == "UJIAN PRAKTEK" && this.state.uprak.is_passed != null && (
								<div className="d-flex-jc-center mb-s">
									<div className="center">
										{ this.state.uprak.is_passed == true ?
											(
												// <h6 className="text-success text-center font-large">
												// 	Selamat! Kamu dinyatakan LULUS Pelatihan
												// </h6>
												<div>	
													<h6 className="text-success text-center">Selamat! Kamu berhasil menguji keterampilan kamu setelah mengikuti kelas ini.</h6>
													<h6 className="text-center">Tetap tingkatkan kembali pengetahuan dan keterampilan kamu untuk mendukung karier yang lebih baik.<br />Nilai Ujian Kamu</h6>
													<h6 className="text-success font-large">{parseInt(this.state.uprak.score)}</h6>
												</div>
											) :
											(
												<div>	
													<h6 className="text-danger text-center">Mohon maaf, Kamu belum berhasil</h6>
													<h6 className="text-center">Kamu bisa menjalankan ujian praktek kembali untuk membuktikan keterampilan kamu setelah mengikuti kelas ini. <br />Selamat mencoba!</h6>
												</div>
											)
										}
										
										{this.state.uprak.is_passed == false &&
										// (
										// 	<div className="mt-s">
										// 		<Link
										// 			to={`/course/${data.slug}/competence-certificate`}
										// 			className="btn capitalize btn-small"
										// 		>
										// 			Lihat Sertifikat
										// 		</Link>
										// 	</div>
										// ):
										(
											<div className="mt-s">
												<a className="btn capitalize btn-small" onClick={this.handleReset}>
													Ulang Ujian Praktek
												</a>
											</div>
										)}
									</div>
								</div>
							)}

							{/* TUGAS PRAKTIK MANDIRI */}

							{this.state.uploaded_tpm.length > 0 && this.state.topic.title == "TUGAS PRAKTIK MANDIRI" && this.state.uprak_tpm.score == null ? (
								<div>
									<h6 className="pl-s font-weight-bold">Kamu dapat mengupload <span className="text-warning">{this.state.uploaded_tpm.length || 0}/{this.state.uprak_tpm.max_uploadfile}</span> file</h6>
									<hr />
									<table>
										<thead>
											<tr>
												<th>Nama File</th>
												<th>Status</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											{(this.state.uploaded_tpm.map((item,index) => {
												return (
													<tr key={index}>
														<td>
														{
															isMobile ? (
																<h6>{this.renderFileName(item.file_name, 'mobile')}</h6>
																):(
																	<h6>{this.renderFileName(item.file_name, 'web')}</h6>
															)
														}
														</td>
														<td>
															{/*{item.is_checked == true && item.is_passed == true && (
																<h6 className="text-success">
																	File ini lulus pengecekan.
																</h6>
															)}

															{item.is_checked == true && item.is_passed == false && (
																<h6 className="text-danger">
																	{item.failed_reason || ''}
																</h6>
															)}

															{item.is_checked == false  && (
																<h6 className="text-warning">
																	Silakan lanjutkan ke sesi berikutnya.
																</h6>
															)}*/}

															{(item.is_checked == true || (item.is_checked == false && (item.failed_reason == null || item.failed_reason.length < 1)))  &&(
																<h6 className="text-warning">
																	Data Anda sudah kami terima. Mohon ditunggu maksimal 2x24 jam untuk hasil penilaian tenaga pelatih.<br/><br/>
																	Silakan lanjut ke sesi berikutnya.
																</h6>
															)}

															{item.is_checked == false && item.failed_reason && item.failed_reason.length > 0  &&(
																<h6 className="text-danger">
																	{item.failed_reason}
																</h6>
															)}
															
														</td>
														<td>
														{item.is_passed == false || item.is_passed == null ? (
															<Modal
															trigger={
																<button className="btn btn-small delete-btn bg-danger">Hapus</button>
															}
														>
															<div className="center">
																<div>
																	<h5>Apakah Anda yakin ingin menghapus file ini?</h5>
																</div>
																<div className="d-flex-jc-center">
																	<button onClick={() => this.deleteFileTugasPraktik(item.id, activeTopic)} className="btn btn-small delete-btn mr-xs modal-close">Ya</button>
																	<button className="btn btn-small delete-btn bg-danger modal-close">Batal</button>
																</div>
															</div>
															</Modal>
														) : null}
														</td>
													</tr>
												)
											}))}
										</tbody>
									</table>
								</div>
							) :""}

							{this.state.topic.title == "TUGAS PRAKTIK MANDIRI" && this.state.upload_tpm == false && this.state.uprak_tpm.max_file == false && (
								this.renderUploadButtonTugasPraktik(activeTopic)
							)}

							{this.state.topic.title == "TUGAS PRAKTIK MANDIRI" && this.state.upload_tpm == true && (
								<div className="wrapper-form-uprak">
									<div>
										<div className="upload-uprak-loader"></div>
										<div className="pt-s mb-xss text-center">Sedang mengupload....
										</div>
									</div>
								</div>
							)}

							{this.state.topic.title == "TUGAS PRAKTIK MANDIRI" && (
								<div className="d-flex-jc-center mb-s">
									<div className="center">
										{ this.state.uprak_tpm.score != null ?
											(
												// <h6 className="text-success text-center font-large">
												// 	Selamat! Kamu dinyatakan LULUS Pelatihan
												// </h6>
												<div>	
													<h6 className="text-success text-center">{this.state.uprak_tpm.comment}</h6>
													<h6 className="text-center">Nilai Tugas Kamu</h6>
													<h6 className="text-success font-large">{parseInt(this.state.uprak_tpm.score)}</h6>
												</div>
											) : ""
										}
									</div>
								</div>
							)}

							<Tabs className="tabs-fixed-width">
								<Tab title="Deskripsi" active> 
								{/* Kilasan */}
									{/*<div className="pad-m bg-grey border-all valign-wrapper">
							<Icon className="font-orange" small>stars</Icon><div className="padl-s"> Bonus <span className="font-orange">+{data.pac_point}PAC</span> jika menyelesaikan {trans.course} ini</div>
						</div>*/}
									<div className="pad-m">
										{data.enrolled && (
											<b className="font-grey">
												Anda sudah terdaftar dalam {trans.course_item} ini
												<br />
												<br />
											</b>
										)}

										<span id="course-title" className="font-medium">
											{data.title}
										</span>
										{/*<div>{data.modules.length} {trans.chapter}</div>
					  <br/>*/}
										<Row>
											{true && (
												<Col l={6} m={6} s={6}>
													<h6 className="price-type">Harga</h6>
													<span id="course-price" className="font-heavy">
														{data.price === 0
															? "GRATIS"
															: FormatPrice(data.price)}
													</span>
												</Col>
											)}
										</Row>

										<hr />
										{data.category && (
											<Link
												to={`/course/catalog?category_id=${data.category.id}`}
											>
												<span className="lp-detail-ctg mr-xs mt-s pad-xs-m">
													{data.category.name}
												</span>
											</Link>
										)}
										<hr />
										<div className="justify" id="course-desc">
											{ReactHtmlParser(data.description)}
										</div>
										<br />
										<hr />
										{data.instructor_avatar && (
											<Image
												src={data.instructor_avatar}
												className="left small circle mr-s"
											/>
										)}
										<b>{data.instructor}</b>
										<br />
										{data.instructor_detail}
										<hr className="mt-sxs" />

										{data.course_journey && <b>{trans.learning_path}</b>}
										<br />
										{data.course_journey && (
											<span>
												{trans.course} ini termasuk dalam kumpulan{" "}
												{trans.learning_path} berikut.
											</span>
										)}
										{data.course_journey && (
											<LearningPathItem data={data.course_journey} />
										)}
									</div>
								</Tab>

								{data.required_courses && (
									<Tab
										className={data.required_courses.length == 0 ? "hide" : ""}
										title="Syarat Modul"
									>
										<div className="pad-m">
											<div className="strong font-grey mb-m">
												Anda harus menyelesaikan Modul berikut terlebih dahulu
												secara berurutan
											</div>
											{data.required_courses.map((course, i) => (
												<div className="valign-wrapper border-bottom mb-s">
													<div className="mnt-s">
														{course.completed && (
															<div className="badge-check left lh-50">
																<Icon className="icon-course">
																	check_circle
																</Icon>
															</div>
														)}

														{!course.completed && (
															<div className="badge left center lh-50">
																{i + 1}
															</div>
														)}
													</div>
													<CourseItem
														hideInstructor="true"
														className="section-card"
														data={course}
													/>
												</div>
											))}

											{data.required_courses.length == 0 && (
												<div className="pad-xl center">
													<img src={BASE_URL + "/img/profile/ic-riwayat.png"} />
													<br />
													<br />
													<div className="strong font-grey">
														{trans.course} ini tidak memiliki syarat
													</div>
												</div>
											)}
										</div>
									</Tab>
								)}

								{/* TODO Bereskan Ini, tab ini ga muncul ketika desktop */}
								{/* <Tab
									title="Materi"
									style={{ display: !isMobile ? "none" : "inherit" }}
								>
									{isMobile && module}
								</Tab> */}

								<Tab className={!isMobile ? "hide" : ""} title="Materi">
									{isMobile && this.ModuleComponent(data,activeTopic)}
								</Tab>
							</Tabs>
						</div>

						{isMobile || <div className="col s4 border-left">{ this.ModuleComponent(data,activeTopic)}</div>}
						<Col s={12} className="pad-m bg-grey">
							<div className="center-align">
								{/* <span className="h5 font-grey mr-s">Bagikan ke</span> */}
								{/* <FacebookShareButton
									className="btn btn-circle mr-xs"
									url={shareUrl}
									title={shareContent}
								>
									<FontAwesome name="facebook" />
								</FacebookShareButton> */}
							</div>
						</Col>
					</div>
				</div>
				<Modal
					trigger={
						<Button id="graduate-btn" className="hide">
							SUBMIT
						</Button>
					}
				>
					<div className="center almost-full">
						<h4>Selamat Anda Telah Menyelesaikan {trans.course} Ini </h4>
						<img
							className="mt-s mb-m"
							src={BASE_URL + "/img/ic_medallion.png"}
						/>
						<div className="mb-m">
							Anda telah menyelesaikan seluruh {trans.chapter} dari{" "}
							{trans.course} ini. Kami memberikan Lembar Sertifikat sebagai bukti
							Anda telah lulus melewati pembelajaran.
						</div>
						<Link to={`/course/${data.slug}/recap`} className="btn modal-close">
							Rekap Nilai
						</Link>
						<h4 />
					</div>
				</Modal>
				<Modal trigger={<Button className="hide" id="btn-redeem" />}>
					{this.getRedeemCouponModal()}
				</Modal>
				<Modal
					id="modal-gameQuiz"
					bottomSheet
					trigger={
						<Button className="hide" id="btn-gameModal"/>
					}
				>
					{
						this.state.gameQuiz_data ? (
							<div>
								<a className="modal-close modal-quizGame right">
									<Icon>clear</Icon>
								</a>
								<h3 className="text-center">Quiz untuk melanjutkan sesi</h3>
								<MultipleChoiceGame isTrue={this.state.isPopUpQuizTrue} notifMessage={this.state.notifPopUpQuizMessage} question={this.state.gameQuiz_data.questionList} answer={this.state.gameQuiz_data.answerList} uuid={this.state.topic.uuid} updateData={(istrue)=>this.updateQuiz(istrue)} nextChapter={()=>this.nextChapter(true, true)}/>
							</div>
						):null
					}
				</Modal>
				{/* start::resolution video modal */}
				<Modal
					trigger={
						<Button id="resolution-video-btn" className="hide">
							Resolution Video
						</Button>
					}
					id="resolution-video-modal"
					// style={{ 
					// 	overflow: 'hidden',
					// 	maxHeight: 'unset'
					// }}
				>
					<div className="center">
						<div>
							<h5>Pilih Resolusi Video Anda</h5>
						</div>
						<div className="d-flex-jc-center mt-l">
							<button onClick={()=>this.handleResolutionVideo(360)} className="btn btn-small bg-success modal-close mr-xs">360P</button>
							<button onClick={()=>this.handleResolutionVideo(720)} className="btn btn-small bg-danger modal-close">720P</button>
						</div>
					</div>
				</Modal>
				{/* end::resolution video modal */}
								{/* MODAL POP UP */}
				{/* <Modal trigger={<Button className="hide" id="btn-modal-youtube" />}
					modalOptions={{ dismissible: false }}
					options={{
						endingTop: '10%',
						inDuration: 250,
						onCloseEnd: null,
						onCloseStart: null,
						onOpenEnd: null,
						onOpenStart: null,
						opacity: 0.5,
						outDuration: 250,
						preventScrolling: true,
						startingTop: '4%'
					}}
				>
					<div className="center almost-full">
							<h5> Klik ok untuk melanjutkan pelajaran ! </h5>
							<div className="mb-m">
									Apakah anda masih ingin melanjutkan sesi video ini?
							</div>
							<Button className="btn modal-close" onClick={this.handleCloseModalVideo}>
								OKE 
							</Button>
						</div>
				</Modal> */}
			</div>
		);
	}
}

export default CourseDetail;



// WEBPACK FOOTER //
// ./src/components/Course/Detail.js